<template>
    <div class="qvp-exam-registration">
        <!-- Static QVP Banner -->
        <div class="banner-section">
            <div class="banner-item">
                <img src="assets/img/banners/QVP-Banner.jpg" alt="QVP Banner" class="banner-image" />
            </div>
        </div>

        <!-- Dynamic Banner Section (from API) -->
        <!-- <div class="banner-section" v-if="landingContent && landingContent.page_content && landingContent.page_content.banners && landingContent.page_content.banners.length > 0">
            <div v-for="(banner, index) in landingContent.page_content.banners" :key="index" class="banner-item">
                <img :src="banner.image" :alt="banner.title || 'Banner'" class="banner-image" />
            </div>
        </div> -->

        <div class="section inset mt-1">
            <div class="wide-block pt-1">
                <div class="listed-detail mt-0">
                    <!-- <h3 class="text-center text-primary mal-text" style="font-size: 18px; margin-bottom: 20px;">
            QVP Exam Registration
          </h3> -->
  
                    <div class="text-center mb-3">
                        <img src="assets/img/QVP NEW LOGO HRIDAYAM.png" alt="QVP Logo" style="height: 60px;">
                    </div>
  
                    <div id="alertBox" class="alert-box" :class="alertClass" v-if="alertMessage">
                        {{ alertMessage }}
                    </div>
  
                    <!-- Title from Landing Content -->
                    <h3 v-if="landingContent && landingContent.page_content && landingContent.page_content.title" 
                        :class="landingContent.page_content.title_class || 'text-center text-primary mal-text qvp-title'">
                        {{ landingContent.page_content.title }}
                    </h3>
                    <h3 v-else class="text-center text-primary mal-text qvp-title">QVP പരീക്ഷ രജിസ്ട്രേഷൻ</h3>
                    
                    <!-- Loading Indicator -->
                    <div v-if="loadingRegistration" class="loading-indicator">
                        <p class="text-center mal-text" style="color: #6c757d; padding: 20px;">
                            Loading...
                        </p>
                    </div>
                    
                    <p class="text-center mal-text qvp-description" v-if="registeredMembers.length > 0 && !loadingRegistration">
                        രജിസ്റ്റർ ചെയ്യുന്നവരെ കാണാൻ താഴെ ഉള്ള ബട്ടൺ ക്ലിക്ക് ചെയ്യുക.
                    </p>

                    <!-- Empty state: no registrations yet - show when API returns empty so user can register -->
                    <div class="qvp-empty-state text-center py-4 px-3" v-if="!loadingRegistration && registeredMembers.length === 0 && unregisteredFamilyMembers.length === 0">
                        <p class="mal-text text-muted mb-2">നിങ്ങൾക്ക് ഇതുവരെ QVP പരീക്ഷയിൽ രജിസ്ട്രേഷൻ നടത്തിയിട്ടില്ല.</p>
                        <p class="mal-text small text-muted mb-3">രജിസ്ടർ ചെയ്യാൻ താഴെയുള്ള ബട്ടൺ ക്ലിക്ക് ചെയ്യുക.</p>
                        <button type="button" class="btn btn-primary btn-sm mal-text" @click="redirectToRegisterPage">
                            + QVP രജിസ്ട്രേഷൻ (Register for QVP)
                        </button>
                    </div>
  
                    <!-- Registered Members List -->
                    <div class="registered-members-section" v-if="registeredMembers.length > 0 && !loadingRegistration">
                        <ul class="listview image-listview inset text mt-0 mb-2"
                            style="background: transparent; border: none; padding: 0;">
                            <li v-for="(member, index) in registeredMembers" :key="member.id || index"
                                class="member-card">
                                <a href="javascript:void(0)" class="item">
                                    <span class="sl-no">{{ index + 1 }}</span>
                                    <div class="in">
                                        <div style="margin-left: 5px; width: 100%;">
                                            <b class="member-name">{{ member.name }}</b>
                                            <footer>
                                                <div class="member-mobile">{{ member.mobile }}</div>
                                                <div class="member-category" v-if="member.category">
                                                    <span class="category-label mal-text">Category:</span>
                                                    <span class="category-value mal-text">{{ getCategoryName(member.category, member.age) }}</span>
                                                    <button v-if="shouldShowEditCategory(member)" type="button" class="btn-edit-category mal-text"
                                                        @click.stop="openEditCategoryModal(member)"
                                                        title="Edit category">
                                                        Edit
                                                    </button>
                                                </div>
                                                <div class="payment-status-badge"
                                                    :class="isMemberPaidOrAttended(member) ? 'text-success' : 'payment-pending'"
                                                    v-if="(member.payment_status || member.exam_attempted) && member.category !== 'kids'">
                                                    [{{ isMemberPaidOrAttended(member) ? 'Fees Paid' : 'Fees Not Paid' }}]
                                                </div>
                                                
                                                <!-- Countdown / Take Exam / Exam ended - show the exam this member can see (restricted by Comments or open). When same category has both, restricted users see that exam; others see the open exam's countdown. -->
                                                <div v-if="isMemberPaidOrAttended(member) && getVisibleExamForMember(member.category, member)" class="mt-2">
                                                    <!-- Before exam start (or before marks publishing): show countdown. Questions page enabled => "Exam starts in"; else "Marks publishing in" (skip for users in Comments - they get early access and see the button below) -->
                                                    <div v-if="getCountdownBlockVisible(getVisibleExamForMember(member.category, member)) && !isMemberInExamComments(getVisibleExamForMember(member.category, member), member)" class="countdown-block mal-text">
                                                            <div v-if="getVisibleExamForMember(member.category, member).form_heading || getVisibleExamForMember(member.category, member).name" class="countdown-exam-name text-primary fw-bold mb-1">
                                                                {{ getVisibleExamForMember(member.category, member).form_heading || getVisibleExamForMember(member.category, member).name }}
                                                            </div>
                                                            <template v-if="questionsPageEnabled(getVisibleExamForMember(member.category, member))">
                                                                <span class="text-primary fw-bold">⏱ പരീക്ഷ ആരംഭിക്കുന്നത് / Exam starts in:</span>
                                                                <div class="countdown-value text-dark mt-1">{{ formatCountdownDisplay(getVisibleExamForMember(member.category, member)) }}</div>
                                                            </template>
                                                            <template v-else>
                                                                <span class="text-primary fw-bold">📊 മാർക്ക് പ്രസിദ്ധീകരിക്കുന്നത് / Marks publishing in:</span>
                                                                <div class="countdown-value text-dark mt-1">{{ formatCountdownToEndDisplay(getVisibleExamForMember(member.category, member)) }}</div>
                                                            </template>
                                                        </div>
                                                        <!-- Take Exam or View Mark button: from actual start time, OR from start of day for users in exam Comments (early access). When questions page disabled, show "View Mark" instead of "Write Exam". -->
                                                        <div v-else-if="isExamStartedForMember(getVisibleExamForMember(member.category, member), member) && !isExamEnded(getVisibleExamForMember(member.category, member)) && canShowExamButtonForMember(getVisibleExamForMember(member.category, member), member)">
                                                            <a :href="getExamPageHashForMember(getVisibleExamForMember(member.category, member).button_url, member)" class="btn btn-exam-quick btn-sm mal-text">
                                                                <template v-if="questionsPageEnabled(getVisibleExamForMember(member.category, member))">📝 പരീക്ഷ എഴുതുക</template>
                                                                <template v-else>📊 ഫലം കാണുക / View Mark</template>
                                                            </a>
                                                        </div>
                                                        <div v-else-if="isExamStarted(getVisibleExamForMember(member.category, member)) && !isExamEnded(getVisibleExamForMember(member.category, member))" class="text-muted small mal-text">
                                                            പരീക്ഷ നടക്കുന്നു / Exam in progress
                                                        </div>
                                                        <!-- After exam end -->
                                                        <div v-else-if="isExamEnded(getVisibleExamForMember(member.category, member))" class="text-muted small mal-text">
                                                            പരീക്ഷ അവസാനിച്ചു
                                                        </div>
                                                </div>
                                                <div v-else-if="isMemberPaidOrAttended(member) && member.category !== 'kids'" class="mt-2">
                                                    <span class="text-muted small mal-text">പരീക്ഷ ഈ കാറ്റഗറിക്ക് ഇപ്പോൾ ലഭ്യമല്ല / Exam not available for this category</span>
                                                </div>
                                                
                                                <!-- Individual Pay Now button: only for unpaid and not-yet-attended members (attended = never show Pay Now again) -->
                                                <div v-if="!isMemberPaidOrAttended(member) && member.category !== 'kids'" style="margin-top: 8px;">
                                                    <a :href="getSinglePaymentUrl(member.id)" 
                                                       class="btn btn-payment-single btn-sm mal-text"
                                                       style="padding: 6px 16px; font-size: 13px; display: inline-block;">
                                                        💳 Pay Now
                                                    </a>
                                                </div>

                                                <!-- Download Hall Ticket: only for General category candidates with marks >= 48 -->
                                                <div v-if="canDownloadAdmitCard(member)" style="margin-top: 8px;">
                                                    <button type="button"
                                                        class="btn btn-admit-card btn-sm mal-text"
                                                        @click.stop="downloadAdmitCard(member)">
                                                        ⬇️ Download Hall Ticket
                                                    </button>
                                                </div>
                                            </footer>
                                        </div>
                                    </div>
                                    <!-- Checkbox removed - not needed after registration -->
                                </a>
                            </li>
                        </ul>

                        <!-- Action Buttons - Only Payment button, no Save button after registration -->
                        <div class="action-buttons-wrapper">
                            <a :href="getPaymentUrl()" class="btn btn-payment-list btn-block btn-sm"
                                v-if="pendingPaymentCount >= 2">
                                Click for Payment (All)
                            </a>
                            
                            <!-- Add Family Members Button - disabled for this phase -->

                            <!-- Kids Exam Center Info - shown when user has kids registration -->
                            <div v-if="displayExamCenters.length > 0 && hasKidsRegistration" class="exam-center-info-box mt-3">
                                <h5 class="exam-center-title mal-text">പരീക്ഷാ കേന്ദ്ര വിവരങ്ങൾ (Kids)</h5>
                                <div v-for="(center, idx) in displayExamCenters" :key="center.id || idx" class="exam-center-details mal-text">
                                    <p v-if="getExamCenterName(center)"><strong>മദ്റസ/കേന്ദ്രം:</strong> {{ getExamCenterName(center) }}</p>
                                    <p v-if="center.convenor_name"><strong>കൺവീനർ:</strong> {{ center.convenor_name }}</p>
                                    <p v-if="center.convenor_phone">
                                        <strong>ഫോൺ:</strong>
                                        <a :href="'tel:' + center.convenor_phone">{{ center.convenor_phone }}</a>
                                    </p>
                                    <p v-if="center.exam_date || center.exam_time">
                                        <strong>Exam Date / Exam Time:</strong>
                                        {{ formatExamCenterDate(center.exam_date) }}{{ center.exam_date && center.exam_time ? ' | ' : '' }}{{ center.exam_time || '' }}
                                    </p>
                                    <hr v-if="idx < displayExamCenters.length - 1" class="exam-center-divider" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Edit Category Modal -->
                    <div class="edit-category-modal-overlay" v-if="editingCategoryMember" @click.self="closeEditCategoryModal">
                        <div class="edit-category-modal edit-category-modal-with-campus">
                            <h5 class="mal-text">Edit Category</h5>
                            <p class="edit-category-member-name">{{ editingCategoryMember.name }}</p>
                            <div class="form-group edit-mobile-row">
                                <label class="form-label mal-text">Mobile number (മൊബൈൽ നമ്പർ)</label>
                                <div class="edit-mobile-with-code">
                                    <select v-model="editMemberCountryCode" class="form-control edit-country-code">
                                        <option v-for="opt in editCountryCodeOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                                    </select>
                                    <input type="tel" v-model="editMemberMobile" class="form-control edit-mobile-input" placeholder="10 digit mobile number"
                                        maxlength="15" inputmode="numeric" pattern="[0-9]*">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label mal-text">Category</label>
                                <select v-model="editCategoryValue" class="form-control" @change="onEditCategoryChange">
                                    <option value="" disabled>Select Category</option>
                                    <option v-for="cat in getAllowedCategoriesForAge(editingCategoryMember.age)" :key="cat.id" :value="cat.id">
                                        {{ cat.title }} ({{ cat.subtitle }})
                                    </option>
                                </select>
                            </div>
                            <!-- Campus details form - shown when Campus is selected -->
                            <template v-if="editCategoryValue === 'campus'">
                                <div class="edit-campus-fields">
                                    <div class="form-group">
                                        <label class="form-label mal-text">Campus (ക്യാമ്പസ്) <span class="text-danger">*</span></label>
                                        <input type="text" v-model="editCampusName" class="form-control" placeholder="Enter campus name">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label mal-text">Course (കോഴ്‌സ്) <span class="text-danger">*</span></label>
                                        <input type="text" v-model="editCampusCourse" class="form-control" placeholder="Enter course name">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label mal-text">Year of Studying (പഠന വർഷം) <span class="text-danger">*</span></label>
                                        <select v-model="editCampusYear" class="form-control">
                                            <option value="" disabled class="mal-text">Select Year</option>
                                            <option v-for="y in 6" :key="y" :value="y" class="mal-text">Year {{ y }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label mal-text">WhatsApp Number (വാട്ട്സാപ് നമ്പർ) <span class="text-danger">*</span></label>
                                        <div class="edit-campus-whatsapp-row">
                                            <input type="checkbox" v-model="editUseSameMobileForCampus" id="edit-same-mobile-campus"
                                                @change="onEditCampusSameMobileChange" style="width: 18px; height: 18px; cursor: pointer; accent-color: #1a418c;">
                                            <label for="edit-same-mobile-campus" class="mal-text" style="cursor: pointer; font-size: 13px; color: #1a418c; margin: 0;">
                                                Use same as member mobile ({{ displayEditMemberFullMobile }})
                                            </label>
                                        </div>
                                        <input type="tel" v-model="editCampusWhatsapp" class="form-control" placeholder="10 digit number"
                                            :disabled="editUseSameMobileForCampus">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label mal-text">Campus District <span class="text-danger">*</span></label>
                                        <select v-model="editCampusDistrictId" class="form-control">
                                            <option value="" disabled class="mal-text">Select Campus District</option>
                                            <option v-for="d in revenueDistricts.filter(d => d.id > 0)" :key="d.id" :value="d.id">{{ d.name }}</option>
                                            <option :value="0" class="mal-text">Out of Kerala</option>
                                        </select>
                                    </div>
                                </div>
                            </template>
                            <div v-if="editCategoryErrorMessage" class="edit-category-error mal-text text-danger mt-2 mb-2">
                                {{ editCategoryErrorMessage }}
                            </div>
                            <div class="edit-category-modal-actions">
                                <button type="button" class="btn btn-secondary btn-sm" @click="closeEditCategoryModal">Cancel</button>
                                <button type="button" class="btn btn-primary btn-sm" :disabled="savingEditCategory || !editCategoryValue || !canSaveEditCategory" @click="saveEditCategory">
                                    {{ savingEditCategory ? 'Saving...' : 'Save' }}
                                </button>
                            </div>
                        </div>
                    </div>
  
                    <!-- Categories Dropdown - Hidden (using inline category selection for family members) -->
                    <!-- This section is kept for public users who don't have family members -->
                    <div class="categories-section" v-if="!isAlreadyRegistered && !loadingRegistration && familyMembers.length === 0" style="display: none;">
                        <h4 class="section-title mal-text">കാറ്റഗറികൾ</h4>
  
                        <div class="form-group">
                            <label class="form-label mal-text">Select Exam Category</label>
                            <select v-model="selectedCategory" class="form-control custom-select"
                                @change="onCategoryChange">
                                <option value="" disabled>Select Category</option>
                                <option v-for="category in categories" :key="category.id" :value="category.id">
                                    {{ category.title }} ({{ category.subtitle }})
                                </option>
                            </select>
                        </div>
  
                        <!-- Category Description -->
                        <div class="category-description-box" v-if="selectedCategory && selectedCategoryData">
                            <h5 class="description-title mal-text">{{ selectedCategoryData.title }}</h5>
                            <p class="description-text mal-text" v-if="selectedCategoryData.description">
                                {{ selectedCategoryData.description }}
                            </p>
                            <div v-if="selectedCategoryData.subCategories && selectedCategoryData.subCategories.length > 0"
                                class="sub-categories">
                                <div v-for="subCat in selectedCategoryData.subCategories" :key="subCat.id"
                                    class="sub-category-item mal-text">
                                    <strong>{{ subCat.title }}:</strong> {{ subCat.description }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Family Members Selection - show unregistered members with checkbox + name -->
                    <div class="family-members-section" v-if="!loadingRegistration && unregisteredFamilyMembers.length > 0">
                        <div class="unregistered-section-header">
                            <h4 class="section-title mal-text">{{ unregisteredFamilyMembers.length > 1 ? 'അംഗങ്ങളെ തിരഞ്ഞെടുക്കുക' : 'രജിസ്ടർ ചെയ്യാത്ത അംഗം' }}</h4>
                            <p class="mal-text" style="font-size: 13px; color: #6c757d; margin-bottom: 15px;">
                                {{ unregisteredFamilyMembers.length > 1 ? 'കുടുംബാംഗങ്ങളിൽ ആരെയാണ് രജിസ്റ്റർ ചെയ്യേണ്ടതെന്ന് തിരഞ്ഞെടുക്കുക' : 'രജിസ്ടർ ചെയ്യാൻ താഴെയുള്ള അംഗത്തെ തിരഞ്ഞെടുക്കുക' }}
                            </p>
                        </div>
                        
                        <!-- Auto-category info note -->
                        <div class="category-info-note" v-if="unregisteredFamilyMembers.some(m => m.age <= 18)">
                            <ion-icon name="information-circle-outline"></ion-icon>
                            <span class="mal-text">18 വയസ്സിൽ താഴെയുള്ള കുട്ടികൾക്ക് വയസ്സ് അടിസ്ഥാനമാക്കി കാറ്റഗറി വരും</span>
                        </div>
                        
                        <div class="family-member-list">
                            <div v-for="member in unregisteredFamilyMembers" :key="member.id" class="family-member-wrapper">
                                <label class="family-member-item">
                                    <input type="checkbox" 
                                           v-model="selectedFamilyMembers" 
                                           :value="member.id"
                                           class="member-checkbox">
                                    <div class="member-info">
                                        <div class="member-name-age">
                                            <strong>{{ member.name }}</strong>
                                            <span class="member-category-auto mal-text" v-if="getKidsSubCategory(member.age) === 'junior'">
                                                Kids - Junior
                                            </span>
                                            <span class="member-category-auto mal-text" v-else-if="getKidsSubCategory(member.age) === 'senior'">
                                                Kids - Senior
                                            </span>
                                            <span class="member-category-auto mal-text" v-else-if="member.age > 12 && member.age <= 18 && !getKidsSubCategory(member.age)">
                                                Teens
                                            </span>
                                        </div>

                                    </div>
                                </label>
                                
                                <!-- Inline Category Selection for age 12 -->
                                <div v-if="member.age === 12 && selectedFamilyMembers.includes(member.id)" 
                                     class="inline-category-select">
                                    <label class="inline-category-label mal-text">കാറ്റഗറി തിരഞ്ഞെടുക്കുക:</label>
                                    <select v-model="memberCategories[member.id]" 
                                            class="form-control inline-category-dropdown"
                                            @change="onMemberCategoryChange(member.id)">
                                        <option value="" disabled>Select Category</option>
                                        <option value="kids">കിഡ്സ് - സീനിയർ (Kids - Senior)</option>
                                        <option value="teens">ടീൻസ് (Teens)</option>
                                    </select>
                                </div>

                                <!-- Inline Category Selection for age 12-18 -->
                                <div v-if="member.age > 12 && member.age <= 18 && selectedFamilyMembers.includes(member.id)" 
                                     class="inline-category-select">
                                    <label class="inline-category-label mal-text">കാറ്റഗറി തിരഞ്ഞെടുക്കുക:</label>
                                    <select v-model="memberCategories[member.id]" 
                                            class="form-control inline-category-dropdown"
                                            @change="onMemberCategoryChange(member.id)">
                                        <option value="" disabled>Select Category</option>
                                        <option value="teens">ടീൻസ് (Teens)</option>
                                        <option value="general">ജനറൽ - General</option>
                                        <option value="global">ഗ്ലോബൽ - Global</option>
                                    </select>
                                </div>

                                <!-- Inline Category Selection for 19+ members -->
                                <div v-if="member.age >= 19 && selectedFamilyMembers.includes(member.id)" 
                                     class="inline-category-select">
                                    <label class="inline-category-label mal-text">കാറ്റഗറി തിരഞ്ഞെടുക്കുക:</label>
                                    <select v-model="memberCategories[member.id]" 
                                            class="form-control inline-category-dropdown"
                                            @change="onMemberCategoryChange(member.id)">
                                        <option value="" disabled>Select Category</option>
                                        <option value="general">ജനറൽ - General</option>
                                        <option value="campus">ക്യാമ്പസ് - Campus</option>
                                        <option value="global">ഗ്ലോബൽ - Global</option>
                                    </select>
                                </div>

                                <!-- Campus-specific fields for 19+ when campus selected -->
                                <div v-if="member.age >= 19 && selectedFamilyMembers.includes(member.id) && memberCategories[member.id] === 'campus' && memberCampusData[member.id]"
                                     class="campus-fields-wrapper mt-2">
                                    <div class="form-group">
                                        <label class="form-label mal-text small">Campus</label>
                                        <input type="text" v-model="memberCampusData[member.id].campus_name" 
                                            class="form-control form-control-sm" placeholder="Campus name">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label mal-text small">Course</label>
                                        <input type="text" v-model="memberCampusData[member.id].campus_course" 
                                            class="form-control form-control-sm" placeholder="Course">
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label mal-text small">Year of Studying</label>
                                        <select v-model="memberCampusData[member.id].campus_year" class="form-control form-control-sm">
                                            <option value="">Select</option>
                                            <option v-for="y in 6" :key="y" :value="y">Year {{ y }}</option>
                                        </select>
                                    </div>
                                    <!-- Phone & WhatsApp: skip for current guide member (use logged-in user details) -->
                                    <template v-if="!isCurrentUserMember(member)">
                                        <div class="form-group">
                                            <label class="form-label mal-text small">Phone Number</label>
                                            <input type="tel" v-model="memberCampusData[member.id].campus_phone" 
                                                class="form-control form-control-sm" placeholder="Phone" maxlength="15">
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label mal-text small">WhatsApp Number</label>
                                            <input type="tel" v-model="memberCampusData[member.id].campus_whatsapp" 
                                                class="form-control form-control-sm" placeholder="WhatsApp" maxlength="15">
                                        </div>
                                    </template>
                                    <div class="form-group" v-else>
                                        <p class="form-text mal-text small text-muted mb-0">
                                            <!-- ഫോൺ / വാട്ട്സാപ്പ് നമ്പർ നിങ്ങളുടെ രജിസ്ടർ ചെയ്ത നമ്പർ ഉപയോഗിക്കും -->
                                        </p>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label mal-text small">Campus District</label>
                                        <select v-model="memberCampusData[member.id].campus_district_id" class="form-control form-control-sm">
                                            <option value="">Select Campus District</option>
                                            <option v-for="d in revenueDistricts" :key="d.id" :value="d.id" v-show="d.id > 0">{{ d.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Confirm Registration Section - Simple agreement checkbox -->
                    <div class="confirm-section" v-if="!loadingRegistration && selectedFamilyMembers.length > 0">
                        <div class="confirm-card">
                            <div class="selected-members-summary">
                                <h5 class="summary-title mal-text">തിരഞ്ഞെടുത്തവർ ({{ selectedFamilyMembers.length }})</h5>
                                <div class="selected-member-tags">
                                    <span v-for="memberId in selectedFamilyMembers" :key="memberId" class="member-tag">
                                        {{ getFamilyMemberName(memberId) }}
                                    </span>
                                </div>
                            </div>
                            <label class="checkbox-label">
                                <input type="checkbox" v-model="isAgreed" class="checkbox-input">
                                <span class="checkbox-text mal-text">ഞാൻ QVP പരീക്ഷയ്ക്ക് രജിസ്റ്റർ ചെയ്യാൻ സമ്മതിക്കുന്നു</span>
                            </label>
                        </div>
                    </div>
  
                    <!-- Submit Button -->
                    <div class="submit-button-wrapper" v-if="!loadingRegistration && selectedFamilyMembers.length > 0">
                        <button type="button" class="btn btn-primary btn-block"
                            :disabled="!allRequiredCategoriesSelected || !isAgreed || loading" @click="handleRegistration">
                            <span v-if="!loading">രജിസ്ട്രേഷൻ പൂർത്തിയാക്കുക</span>
                            <span v-else>രജിസ്റ്റർ ചെയ്യുന്നു...</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Video Section -->
        <div class="section inset mt-1" v-if="landingContent && landingContent.page_content && landingContent.page_content.video_text && landingContent.page_content.video_link">
            <div class="wide-block pt-1">
                <div class="listed-detail mt-0">
                    <div class="video-section">
                        <p class="mal-text text-center" v-html="landingContent.page_content.video_text"></p>
                        <div class="video-wrapper" v-if="landingContent.page_content.video_link">
                            <iframe :src="landingContent.page_content.video_link" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowfullscreen
                                    class="video-iframe"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            
        <!-- Document Download Card - From Landing Content -->
        <div class="section inset mt-1" v-if="landingContent && landingContent.page_content && landingContent.page_content.description">
            <div class="wide-block pt-1">
                <div class="listed-detail mt-0">
                    <div class="document-download-card" v-html="landingContent.page_content.description"></div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
    import UserService from '../services/user.service';
  
    export default {
        name: 'QVPExamRegistration',
        data() {
            return {
                loading: false,
                loadingRegistration: true,
                alertMessage: '',
                alertClass: '',
                selectedCategory: '',
                isAgreed: false,
                isAlreadyRegistered: false,
                registrationData: null,
                registeredMembers: [],
                selectedMembers: [],
                familyMembers: [], // All family members from members table
                selectedFamilyMembers: [], // Selected family members for QVP registration
                memberCategories: {}, // Track category for each member (key: member_id, value: category)
                memberCampusData: {}, // Campus fields per member when category is campus
                revenueDistricts: [], // Kerala districts for campus
                editingCategoryMember: null, // Member whose category is being edited
                editCategoryValue: '',
                editCategoryErrorMessage: '', // Shown in red in modal when save fails (e.g. cannot change after exam)
                savingEditCategory: false,
                editCampusName: '',
                editCampusCourse: '',
                editCampusYear: '',
                editCampusWhatsapp: '',
                editCampusDistrictId: '',
                editUseSameMobileForCampus: false,
                editMemberMobile: '', // Editable mobile for the member being edited
                editMemberCountryCode: '91', // Country code for the member being edited
                editCountryCodeOptions: [
                    { value: '91', label: '+91 India' },
                    { value: '971', label: '+971 UAE' },
                    { value: '968', label: '+968 Oman' },
                    { value: '966', label: '+966 Saudi' },
                    { value: '974', label: '+974 Qatar' },
                    { value: '973', label: '+973 Bahrain' },
                    { value: '965', label: '+965 Kuwait' },
                    { value: '960', label: '+960 Maldives' },
                    { value: '44', label: '+44 UK' },
                    { value: '1', label: '+1 US/Canada' },
                    { value: '61', label: '+61 Australia' },
                    { value: '60', label: '+60 Malaysia' },
                    { value: '65', label: '+65 Singapore' },
                    { value: '94', label: '+94 Sri Lanka' },
                    { value: 'other', label: 'Other' },
                ],
                landingContent: null, // Landing content from get-landing-content API
                loadingLandingContent: false,
                examCenter: null, // Zone exam center for kids (madrasa, convenor, phone)
                zoneExamCenters: [], // Fetched from qvp-kids-exam-centers when API doesn't provide
                countdownNow: Math.floor(Date.now() / 1000), // Current time (epoch sec) for countdown; updated every second
                countdownTimer: null,
                categories: [
                    {
                        id: 'general',
                        title: 'ജനറൽ (പ്രായ ഭേദമന്യേ)',
                        subtitle: 'General (Age No Bar)',
                        description: 'സൂറ: സജദ, സൂറ: അഹ്സാബ്, സൂറ: സബഅ് - അമാനി മൗലവി തഫ്സീർ'
                    },
                    {
                        id: 'campus',
                        title: 'ക്യാമ്പസ് (Campus - ക്യാമ്പസ് വിദ്യാർത്ഥികൾക്ക്)',
                        subtitle: 'Campus (For Campus Students)',
                        description: 'സൂറ: സജദ - അമാനി മൗലവി തഫ്സീർ'
                    },
                    {
                        id: 'teens',
                        title: 'ടീൻസ് (12 മുതൽ 18 വയസ് വരെയുള്ള വിദ്യാർത്ഥികൾക്ക്)',
                        subtitle: 'Teens (For Students aged 12 to 18 years)',
                        description: 'സൂറ: ഫാത്വിഹ - പ്രത്യേകം തയ്യാറാക്കിയ മൊഡ്യൂൾ'
                    },
                    {
                        id: 'kids',
                        title: 'കിഡ്സ് (12 വയസ് വരെയുള്ള വിദ്യാർത്ഥികൾക്ക്)',
                        subtitle: 'Kids (For Students up to 12 years)',
                        description: '',
                        subCategories: [
                            {
                                id: 'junior',
                                title: 'കാറ്റഗറി 1: ജൂനിയർ',
                                description: '2017 ന് ശേഷം ജനിച്ചവർ'
                            },
                            {
                                id: 'senior',
                                title: 'കാറ്റഗറി 2 സീനിയർ',
                                description: '2014 ന് ശേഷം ജനിച്ചവർ'
                            }
                        ]
                    },
                    {
                        id: 'global',
                        title: 'ഗ്ലോബൽ (ഔട്ട് ഓഫ് കേരള പരീക്ഷാർത്ഥികൾക്ക്, ഓൺലൈൻ പരീക്ഷ)',
                        subtitle: 'Global (For Out of Kerala Candidates, Online Exam)',
                        description: 'സൂറ: സജദ, സൂറ: അഹ്സാബ്, സൂറ: സബഅ് - അമാനി മൗലവി തഫ്സീർ'
                    }
                ]
            };
        },
        computed: {
            currentUser() {
                return this.$store.state.auth.user;
            },
            displayMobile() {
                if (!this.currentUser) return '';

                // Try to get mobile from user object
                if (this.currentUser.mobile) {
                    return this.currentUser.mobile;
                }

                // Extract mobile from username (username format: country_code + mobile)
                if (this.currentUser.username) {
                    const username = this.currentUser.username.toString();
                    const cc = (this.currentUser.country_code || '').toString();

                    // If we know the user's country code, strip it from the beginning
                    if (cc && username.startsWith(cc) && username.length > cc.length) {
                        return username.substring(cc.length);
                    }

                    // Fallback: if username is numeric and longer than 10, assume it might be (country_code + national_number)
                    // Return as-is (public APIs may expect the exact stored value).
                    return username;
                }

                return '';
            },
            selectedCategoryData() {
                if (!this.selectedCategory) return null;
                return this.categories.find(cat => cat.id === this.selectedCategory);
            },
            hasPendingPayments() {
                return this.registeredMembers.some(member =>
                    !this.isMemberPaidOrAttended(member) &&
                    member.payment_status !== 'Paid' &&
                    (member.payment_pending || member.payment_status === 'Pending')
                );
            },
            pendingPaymentCount() {
                return this.registeredMembers.filter(member =>
                    !this.isMemberPaidOrAttended(member) && member.payment_status !== 'Paid' && member.category !== 'kids'
                ).length;
            },
            hasKidsRegistration() {
                return this.registeredMembers.some(m => 
                    m.category === 'kids' || (m.category && String(m.category).toLowerCase().includes('kids'))
                );
            },
            canSaveEditCategory() {
                if (!this.editCategoryValue) return false;
                if (this.editCategoryValue !== 'campus') return true;
                const hasCampusName = !!((this.editCampusName || '').trim());
                const hasCampusCourse = !!((this.editCampusCourse || '').trim());
                const hasCampusYear = !!this.editCampusYear;
                const hasWhatsapp = this.editUseSameMobileForCampus || !!((this.editCampusWhatsapp || '').trim());
                const hasDistrict = this.editCampusDistrictId !== '' && this.editCampusDistrictId !== null && this.editCampusDistrictId !== undefined;
                return hasCampusName && hasCampusCourse && hasCampusYear && hasWhatsapp && hasDistrict;
            },
            displayEditMemberFullMobile() {
                if (!this.editMemberMobile) return '—';
                const code = this.editMemberCountryCode && this.editMemberCountryCode !== 'other' ? this.editMemberCountryCode : '';
                return code ? '+' + code + ' ' + this.editMemberMobile : this.editMemberMobile;
            },
            displayExamCenters() {
                // Prefer API exam_center; fallback to zoneExamCenters from qvp-kids-exam-centers
                if (this.examCenter) return [this.examCenter];
                return this.zoneExamCenters || [];
            },
            examPageUrl() {
                if (!this.landingContent || !this.landingContent.exam_form) return '';
                const url = this.landingContent.exam_form.button_url;
                if (!url || typeof url !== 'string') return '';
                // App uses hash routing: use #/path so the link stays in-app and opens the Exam route
                if (url.startsWith('/') && !url.startsWith('//')) {
                    return '#' + url;
                }
                return url;
            },
            // All active exams to show on frontend (from exam_forms; fallback to single exam_form)
            examFormsList() {
                if (!this.landingContent) return [];
                const forms = this.landingContent.exam_forms;
                if (Array.isArray(forms) && forms.length > 0) return forms;
                const single = this.landingContent.exam_form;
                if (single && single.button_url) return [single];
                return [];
            },
            // Unique categories that the user (and family) have registered for (e.g. ['general', 'campus'])
            registeredCategories() {
                if (!this.registeredMembers || this.registeredMembers.length === 0) return [];
                const cats = this.registeredMembers
                    .map(m => (m.category && String(m.category).toLowerCase().trim()) || '')
                    .filter(Boolean);
                return [...new Set(cats)];
            },
            // Only show exam cards for categories that the user has registered for (and that have an active exam)
            examFormsListFiltered() {
                const list = this.examFormsList;
                const allowed = this.registeredCategories;
                if (allowed.length === 0) return [];
                return list.filter(exam => {
                    const cat = this.getExamCategory(exam);
                    return cat && allowed.includes(cat);
                });
            },
            // Exams list, but restricted to categories where user has at least one Paid registration
            examFormsListPaidOnly() {
                const list = this.examFormsListFiltered;
                if (!list.length) return [];
                return list.filter(exam => {
                    const cat = this.getExamCategory(exam);
                    return cat && this.hasPaidRegistrationForCategory(cat);
                });
            },
            needsCategorySelection() {
                // Check if any selected family member needs category selection (age 12, 12-18, or 19+)
                return this.selectedFamilyMembers.some(memberId => {
                    const member = this.familyMembers.find(m => m.id === memberId);
                    return member && (member.age === 12 || (member.age > 12 && member.age <= 18) || member.age >= 19);
                });
            },
            unregisteredFamilyMembers() {
                // Filter out only already registered members (include current user in the list)
                if (!this.familyMembers || this.familyMembers.length === 0) {
                    return [];
                }
                
                return this.familyMembers.filter(member => {
                    // Only exclude registered members
                    return !member.is_registered;
                });
            },
            allRequiredCategoriesSelected() {
                // Check if all members who need category selection have one selected (age 12, 12-18, or 19+)
                if (this.selectedFamilyMembers.length === 0) {
                    return false;
                }
                
                for (const memberId of this.selectedFamilyMembers) {
                    const member = this.familyMembers.find(m => m.id === memberId);
                    if (member) {
                        // Age 12, 12-18, or 19+ need category selection
                        if (member.age === 12 || (member.age > 12 && member.age <= 18) || member.age >= 19) {
                            if (!this.memberCategories[memberId]) {
                                return false;
                            }
                            // Campus category: validate campus fields are filled
                            if (this.memberCategories[memberId] === 'campus') {
                                const cd = this.memberCampusData[memberId];
                                if (!cd || !cd.campus_name || !cd.campus_course || !cd.campus_year ||
                                    !cd.campus_district_id) {
                                    return false;
                                }
                                // Phone/WhatsApp required only for non–guide members (guide member uses logged-in user details)
                                if (!this.isCurrentUserMember(member) &&
                                    (!cd.campus_phone || !cd.campus_whatsapp)) {
                                    return false;
                                }
                            }
                        }
                    }
                }
                
                return true;
            }
        },
        watch: {
            selectedFamilyMembers: {
                handler(newVal) {
                    // Auto-set default categories when members are selected
                    newVal.forEach(memberId => {
                        // Only set default if category is not already set
                        if (!this.memberCategories[memberId]) {
                            const member = this.familyMembers.find(m => m.id === memberId);
                            if (member) {
                                if (member.age === 12) {
                                    // Age 12: Default to Kids with Senior
                                    this.memberCategories[memberId] = 'kids';
                                } else if (member.age > 12 && member.age <= 18) {
                                    // Age 12-18: Default to Teens
                                    this.memberCategories[memberId] = 'teens';
                                } else if (member.age >= 19) {
                                    // Age 19+: Default to General
                                    this.memberCategories[memberId] = 'general';
                                }
                            }
                        }
                    });
                },
                deep: true
            },
            '$route'(to) {
                // Refresh registration list when navigating to this page
                if (to.path === '/qvp/exam' && this.currentUser) {
                    this.checkExistingRegistration();
                }
            }
        },
        mounted() {
            if (!this.currentUser) {
                this.$router.push('/login');
            }
            this.$root.updateParent('QVP Exam Registration');
            this.loadLandingContent(); // Load landing content first
            this.checkExistingRegistration(); // This will load family members after registration check
            this.fetchRevenueDistricts(); // For campus district dropdown
            this.countdownNow = Math.floor(Date.now() / 1000);
            this.countdownTimer = setInterval(() => {
                this.countdownNow = Math.floor(Date.now() / 1000);
            }, 1000);
        },
        beforeUnmount() {
            if (this.countdownTimer) clearInterval(this.countdownTimer);
        },
        activated() {
            // Refresh registration list when component is activated (e.g., returning from registration page)
            if (this.currentUser) {
                this.checkExistingRegistration();
            }
        },
        methods: {
            getMemberMarks(member) {
                if (!member) return null;
                // Prefer explicit numeric fields if backend provides them.
                const direct = member.marks_scored ?? member.marks ?? member.mark ?? member.qvp_exam_mark;
                if (direct !== undefined && direct !== null && direct !== '') {
                    const n = Number(direct);
                    return Number.isFinite(n) ? n : null;
                }
                // Fallback: parse from exam_status string (some APIs include marks in status text)
                const status = (member.exam_status && String(member.exam_status)) || '';
                if (!status) return null;
                const matches = status.match(/(\d+(\.\d+)?)/g);
                if (!matches || matches.length === 0) return null;
                const last = Number(matches[matches.length - 1]);
                return Number.isFinite(last) ? last : null;
            },
            canDownloadAdmitCard(member) {
                if (!member) return false;
                const m = this.getMemberMarks(member);
                // Backend also requires center assignment; show button only when assigned.
                const hasCenter = !!(member.assigned_center_id || member.assigned_center_name);
                return m != null && m >= 48 && hasCenter;
            },
            downloadAdmitCard(member) {
                const regId = member?.exam_reg_id || member?.id;
                if (!regId) return;
                UserService.addAdmin('qvp-admit-card-pdf-link', { id: regId }).then((response) => {
                    const payload = response?.data;
                    const link = payload?.data?.link;
                    if (payload?.status === 'success' && link) {
                        window.location.href = link;
                    } else {
                        this.showAlert(payload?.message || 'Admit card not available.', 'danger');
                    }
                }).catch(() => {
                    this.showAlert('Admit card download failed.', 'danger');
                });
            },
            async loadLandingContent() {
                this.loadingLandingContent = true;
                try {
                    const response = await UserService.addAdmin('get-landing-content', {
                        page: 'qvp',
                        language: 'ml'
                    });
                    
                    if (response.data && response.data.status === 'success' && response.data.data) {
                        this.landingContent = response.data.data;
                        console.log('Landing content loaded:', this.landingContent);
                    }
                } catch (error) {
                    console.error('Error loading landing content:', error);
                    // Don't show error to user, just log it
                } finally {
                    this.loadingLandingContent = false;
                }
            },
            isMemberRegisteredForQvp(member) {
                if (!member) return false;
                // Backend provides event_reg + exam_reg_id for QVP status checks
                if (member.exam_reg_id) return true;
                const v = member.event_reg;
                // Treat only explicit '1' as registered; 0, '0', null, undefined = not registered
                return v === 1 || v === '1';
            },
            getPersistedRegisteredIds() {
                try {
                    const raw = sessionStorage.getItem('qvp_recently_registered');
                    if (!raw) return new Set();
                    const data = JSON.parse(raw);
                    const maxAge = 30 * 60 * 1000; // 30 minutes
                    if (data.ts && Date.now() - data.ts > maxAge) {
                        sessionStorage.removeItem('qvp_recently_registered');
                        return new Set();
                    }
                    return new Set((data.ids || []).map(String));
                } catch (e) {
                    return new Set();
                }
            },
            persistRegisteredIds(ids) {
                try {
                    const existing = this.getPersistedRegisteredIds();
                    ids.forEach((id) => existing.add(String(id)));
                    sessionStorage.setItem(
                        'qvp_recently_registered',
                        JSON.stringify({ ids: [...existing], ts: Date.now() })
                    );
                } catch (e) {
                    /* ignore */
                }
            },
            clearPersistedRegisteredIds(ids) {
                try {
                    const existing = this.getPersistedRegisteredIds();
                    if (ids && ids.length) {
                        ids.forEach((id) => existing.delete(String(id)));
                    } else {
                        existing.clear();
                    }
                    if (existing.size === 0) {
                        sessionStorage.removeItem('qvp_recently_registered');
                    } else {
                        sessionStorage.setItem(
                            'qvp_recently_registered',
                            JSON.stringify({ ids: [...existing], ts: Date.now() })
                        );
                    }
                } catch (e) {
                    /* ignore */
                }
            },
            applyQvpMembers(members) {
                const safeMembers = Array.isArray(members) ? members : [];
                // Preserve locally-registered member IDs (in-memory + persisted across navigation)
                const fromMemory = new Set(
                    (this.registeredMembers || []).map((r) => String(r.id))
                );
                const fromSession = this.getPersistedRegisteredIds();
                const previouslyRegisteredIds = new Set([...fromMemory, ...fromSession]);

                // Normalize to a consistent shape
                const normalized = safeMembers.map((m) => ({
                    id: m.member_id || m.id,
                    member_id: m.member_id,
                    exam_reg_id: m.exam_reg_id,
                    name: m.name || m.member_name,
                    age: m.age,
                    gender: m.gender,
                    mobile: m.mobile,
                    category: m.category,
                    marks_scored: m.marks_scored ?? null,
                    assigned_center_id: m.assigned_center_id ?? null,
                    assigned_center_name: m.assigned_center_name ?? null,
                    event_reg: m.event_reg,
                    payment_status: m.payment_status,
                    payment_pending: m.payment_pending,
                    payment_status_text: m.payment_status_text,
                    public: m.public,
                    exam_done: m.exam_done,
                    exam_attempted: m.exam_attempted,
                    exam_taken: m.exam_taken,
                    exam_status: m.exam_status
                }));

                // Registered list (include standalone/public registrations too)
                const fromApi = normalized
                    .filter((m) => this.isMemberRegisteredForQvp(m))
                    .map((m) => ({
                        id: m.id,
                        exam_reg_id: m.exam_reg_id,
                        name: m.name,
                        age: m.age,
                        gender: m.gender,
                        mobile: m.mobile,
                        category: m.category,
                        payment_status: m.payment_status,
                        payment_pending: m.payment_pending,
                        payment_status_text: m.payment_status_text,
                        exam_done: m.exam_done,
                        exam_attempted: m.exam_attempted,
                        exam_taken: m.exam_taken,
                        exam_status: m.exam_status,
                        marks_scored: m.marks_scored ?? null,
                        assigned_center_id: m.assigned_center_id ?? null,
                        assigned_center_name: m.assigned_center_name ?? null,
                    }));
                // Merge locally-registered members not yet in API response (handles API lag after registration)
                const apiIds = new Set(fromApi.map((r) => String(r.id)));
                const localOnly = (this.registeredMembers || []).filter(
                    (r) => !apiIds.has(String(r.id))
                );
                this.registeredMembers = [...fromApi, ...localOnly];
                // Clear persisted IDs for members the API now returns as registered (backend caught up)
                if (apiIds.size > 0) {
                    this.clearPersistedRegisteredIds([...apiIds]);
                }

                // Family members selection list (ONLY real member records)
                // Standalone public registrations may not have member_id; exclude them from selection.
                // Preserve is_registered for recently registered members (API may not reflect yet)
                this.familyMembers = normalized
                    .filter((m) => !!m.member_id)
                    .map((m) => {
                        const fromApi = this.isMemberRegisteredForQvp(m);
                        const fromLocal = previouslyRegisteredIds.has(String(m.id)) || previouslyRegisteredIds.has(String(m.member_id));
                        return {
                            id: m.id,
                            name: m.name,
                            age: m.age,
                            gender: m.gender,
                            mobile: m.mobile,
                            is_registered: fromApi || fromLocal
                        };
                    });

                // Update top-level flags
                if (this.registeredMembers.length > 0) {
                    this.isAlreadyRegistered = true;
                    this.registrationData = this.registeredMembers[0];
                    if (this.registrationData.category) {
                        this.selectedCategory = this.registrationData.category;
                    }
                } else {
                    this.isAlreadyRegistered = false;
                    this.registrationData = null;
                }
            },
            markLocalRegistrationSuccess(memberId, category) {
                // Immediately reflect success in UI (remove from unregistered list)
                const member = this.familyMembers.find((m) => m.id === memberId);
                if (member) {
                    member.is_registered = true;
                }

                // Ensure the registered list shows it right away (backend refresh will fill exam_reg_id/payment status)
                const alreadyInRegistered = this.registeredMembers.some((m) => m.id === memberId);
                if (!alreadyInRegistered && member) {
                    this.registeredMembers.push({
                        id: memberId,
                        exam_reg_id: null,
                        name: member.name,
                        age: member.age,
                        gender: member.gender,
                        mobile: member.mobile,
                        category: category,
                        payment_status: category === 'kids' ? 'Paid' : 'Pending',
                        payment_pending: category === 'kids' ? false : true
                    });
                }

                if (this.registeredMembers.length > 0) {
                    this.isAlreadyRegistered = true;
                }
            },
            checkExistingRegistration() {
                this.loadingRegistration = true;
                
                // Check if user has signup_url = 'qvp' (public user)
                const isPublicUser = this.currentUser && this.currentUser.signup_url === 'qvp';
                
                if (isPublicUser) {
                    // For public users, check using their mobile number via public API
                    this.checkPublicRegistration();
                } else {
                    // For guide members, use the standard auto-form-submit API
                    this.checkGuideRegistration();
                }
            },
            checkPublicRegistration() {
                // Check public QVP registrations by mobile number
                const mobile = this.displayMobile;
                
                // Prepare headers with auth token if user is logged in (so backend can link by user_id)
                const headers = {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                };
                const user = this.currentUser;
                if (user && user.accessToken) {
                    headers['Authorization'] = 'Bearer ' + user.accessToken;
                }
                
                fetch('https://guideportal.wisdomislam.org/api/public/qvp/my-registration', {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify({ mobile: mobile })
                })
                .then(response => response.json())
                .then(data => {
                    
                    if (data.status === 'success' && data.data && data.data.length > 0) {
                        this.loadingRegistration = false;
                        if (data.exam_centers && data.exam_centers.length > 0) {
                            this.examCenter = null;
                            this.zoneExamCenters = data.exam_centers;
                        } else if (data.exam_center) {
                            this.examCenter = data.exam_center;
                            this.zoneExamCenters = [];
                        } else {
                            this.examCenter = null;
                            this.zoneExamCenters = [];
                        }
                        // Map public registrations to the format expected by the component
                        this.registeredMembers = data.data.map(reg => ({
                            id: reg.id,
                            exam_reg_id: reg.id,
                            name: reg.name,
                            mobile: reg.mobile,
                            category: reg.category,
                            marks_scored: reg.marks_scored ?? null,
                            assigned_center_id: reg.assigned_center_id ?? null,
                            assigned_center_name: reg.assigned_center_name ?? null,
                            payment_status: reg.payment_status || 'Pending',
                            payment_pending: reg.payment_status !== 'Paid',
                            event_reg: 1,
                            exam_done: reg.exam_done,
                            exam_attempted: reg.exam_attempted,
                            exam_taken: reg.exam_taken,
                            exam_status: reg.exam_status
                        }));
                        
                        this.isAlreadyRegistered = true;
                        this.registrationData = this.registeredMembers[0];
                        
                        if (this.registrationData.category) {
                            this.selectedCategory = this.registrationData.category;
                        }
                    } else {
                        // No registrations found via Public API
                        // Fallback to checking authenticated QVP status (auto-form-submit)
                        console.log('No public registration found, checking authenticated QVP status...');
                        this.checkGuideRegistration();
                    }
                })
                .catch(error => {
                    console.error('Error checking public registration:', error);
                    // Fallback to checking authenticated QVP status on error
                    console.log('Public registration check failed, checking authenticated QVP status...');
                    this.checkGuideRegistration();
                });
            },
            checkGuideRegistration() {
                // For guide users, ALWAYS use the QVP status response from auto-form-submit (backend returns event_reg + exam_reg_id).
                // Relying on landing content causes stale/incorrect "need to register" UI.
                this.loadingRegistration = true;

                UserService.addAdmin('auto-form-submit', {
                    form_name: 'QVP_REGISTRATION',
                    user_type: 'P' // status-check mode when category/member_id are not provided
                }).then(
                    (response) => {
                        const payload = response?.data;
                        const members = payload?.data?.members || [];
                        console.log('QVP status members (auto-form-submit):', members);

                        if (payload && payload.status === 'success') {
                            this.applyQvpMembers(members);
                            this.examCenter = payload?.data?.exam_center || null;
                            // Fetch zone exam centers for kids if API didn't provide and user has kids registration
                            const hasKids = this.registeredMembers.some(
                                (m) => m.category === 'kids' || (m.category && String(m.category).toLowerCase().includes('kids'))
                            );
                            if (hasKids && !this.examCenter && this.currentUser?.zone_id) {
                                this.fetchZoneExamCenters();
                            }
                            // Merge any additional family members (if API provides more) with updated registration flags
                            this.loadFamilyMembers();
                        } else {
                            // Treat as not registered if backend returns non-success
                            this.isAlreadyRegistered = false;
                            this.registeredMembers = [];
                            this.familyMembers = [];
                            this.registrationData = null;
                            this.examCenter = null;
                        }
                    },
                    (error) => {
                        console.error('Error checking QVP registration (auto-form-submit):', error);
                        this.isAlreadyRegistered = false;
                        this.registeredMembers = [];
                        this.familyMembers = [];
                        this.registrationData = null;
                        this.examCenter = null;
                        this.zoneExamCenters = [];
                    }
                ).finally(() => {
                    this.loadingRegistration = false;
                });
            },
            handleSave() {
                // Handle save action for selected members
                this.loading = true;
                // Add save logic here if needed
                setTimeout(() => {
                    this.loading = false;
                    this.showAlert('Saved successfully', 'success');
                }, 1000);
            },
            getCategoryName(categoryId, age) {
                console.log('Getting category name for:', categoryId, 'age:', age);
                const category = this.categories.find(cat => cat.id === categoryId);
                
                if (!category) {
                    return categoryId;
                }
                
                // For kids category, add sub-category based on age
                if (categoryId === 'kids' && age) {
                    const subCategory = this.getKidsSubCategory(age);
                    if (subCategory === 'junior') {
                        return 'കിഡ്സ് - ജൂനിയർ (Kids - Junior)';
                    } else if (subCategory === 'senior') {
                        return 'കിഡ്സ് - സീനിയർ (Kids - Senior)';
                    }
                }
                
                // Campus: full descriptive text
                if (categoryId === 'campus') {
                    return 'അൽ ബയാൻ (ക്യാമ്പസ് വിദ്യാർത്ഥികൾക്ക്) : സൂറ: സജദ - അമാനി മൗലവി തഫ്സീർ';
                }
                
                const result = `${category.title} (${category.subtitle})`;
                console.log('Category found:', category, 'Result:', result);
                return result;
            },
            getAllowedCategoriesForAge(age) {
                if (age == null || age === '') return this.categories.filter(c => ['general', 'teens', 'campus', 'global', 'kids'].includes(c.id));
                const a = parseInt(age, 10);
                if (a === 12) return this.categories.filter(c => c.id === 'kids' || c.id === 'teens');
                if (a < 12) return this.categories.filter(c => c.id === 'kids');
                if (a > 12 && a < 18) return this.categories.filter(c => ['teens', 'general', 'global'].includes(c.id));
                if (a === 18) return this.categories.filter(c => ['teens', 'general', 'campus', 'global'].includes(c.id));
                return this.categories.filter(c => ['general', 'campus', 'global'].includes(c.id));
            },
            openEditCategoryModal(member) {
                this.editCategoryErrorMessage = '';
                this.editingCategoryMember = member;
                this.editCategoryValue = member.category || '';
                this.editMemberMobile = (member.mobile || '').replace(/\D/g, '');
                const cc = (member.country_code || '').toString().replace(/\D/g, '') || '91';
                this.editMemberCountryCode = this.editCountryCodeOptions.some(o => o.value === cc) ? cc : '91';
                this.resetEditCampusFields();
                if (member.category === 'campus' && (member.mobile || this.editMemberMobile)) {
                    this.editUseSameMobileForCampus = true;
                    this.editCampusWhatsapp = this.editMemberMobile || member.mobile || '';
                }
            },
            closeEditCategoryModal() {
                this.editingCategoryMember = null;
                this.editCategoryValue = '';
                this.editCategoryErrorMessage = '';
                this.editMemberMobile = '';
                this.editMemberCountryCode = '91';
                this.resetEditCampusFields();
            },
            resetEditCampusFields() {
                this.editCampusName = '';
                this.editCampusCourse = '';
                this.editCampusYear = '';
                this.editCampusWhatsapp = '';
                this.editCampusDistrictId = '';
                this.editUseSameMobileForCampus = false;
            },
            onEditCategoryChange() {
                if (this.editCategoryValue !== 'campus') this.resetEditCampusFields();
            },
            onEditCampusSameMobileChange() {
                if (this.editUseSameMobileForCampus) {
                    this.editCampusWhatsapp = this.editMemberMobile || (this.editingCategoryMember && this.editingCategoryMember.mobile) || '';
                } else {
                    this.editCampusWhatsapp = '';
                }
            },
            async saveEditCategory() {
                if (!this.editingCategoryMember || !this.editCategoryValue) return;
                if (this.editCategoryValue === 'campus' && !this.canSaveEditCategory) {
                    this.showAlert('Please fill all campus details (Campus name, Course, Year, WhatsApp, District).', 'error');
                    return;
                }
                const regId = this.editingCategoryMember.exam_reg_id || this.editingCategoryMember.id;
                const payload = { id: regId, category: this.editCategoryValue };
                const mobileTrimmed = (this.editMemberMobile || '').replace(/\D/g, '').trim();
                if (mobileTrimmed) payload.mobile = mobileTrimmed;
                const code = (this.editMemberCountryCode && this.editMemberCountryCode !== 'other') ? String(this.editMemberCountryCode).replace(/\D/g, '') : '91';
                if (code) payload.country_code = code;
                if (this.editCategoryValue === 'campus') {
                    payload.campus_name = (this.editCampusName || '').trim();
                    payload.campus_course = (this.editCampusCourse || '').trim();
                    payload.campus_year = this.editCampusYear;
                    payload.campus_whatsapp = this.editUseSameMobileForCampus ? (this.editMemberMobile || this.editingCategoryMember.mobile || this.editCampusWhatsapp) : (this.editCampusWhatsapp || '').trim();
                    const districtId = this.editCampusDistrictId === 0 || this.editCampusDistrictId === '0' ? 0 : this.editCampusDistrictId;
                    payload.campus_district_name = districtId === 0 ? 'Out of Kerala' : (this.revenueDistricts.find(d => d.id == districtId) || {}).name || '';
                }
                this.editCategoryErrorMessage = '';
                this.savingEditCategory = true;
                try {
                    const response = await UserService.addAdmin('update-my-qvp-category', payload);
                    if (response && response.data && (response.data.status === 'success' || response.data.status == 'success')) {
                        if (response.data.data && Array.isArray(response.data.data.members)) {
                            this.applyQvpMembers(response.data.data.members);
                        } else {
                            this.checkExistingRegistration();
                        }
                        this.showAlert('Category updated successfully', 'success');
                        this.closeEditCategoryModal();
                    } else {
                        // Show message in modal in red (e.g. "Cannot change category after exam is completed")
                        const msg = response.data?.message || 'Failed to update category';
                        this.editCategoryErrorMessage = msg;
                        this.showAlert(msg, response.data?.status === 'warning' ? 'warning' : 'error');
                    }
                } catch (err) {
                    const msg = err.response?.data?.message || err.message || 'Failed to update category';
                    this.showAlert(msg, 'error');
                } finally {
                    this.savingEditCategory = false;
                }
            },
            getExamPageHash(buttonUrl) {
                if (!buttonUrl || typeof buttonUrl !== 'string') return '#';
                if (buttonUrl.startsWith('/') && !buttonUrl.startsWith('//')) return '#' + buttonUrl;
                return buttonUrl;
            },
            // Build exam page URL for a specific member + category so exam page can scope to that candidate
            getExamPageHashForMember(buttonUrl, member) {
                const base = this.getExamPageHash(buttonUrl); // e.g. "#/online-exam/50"
                if (!member) return base;

                const regId = member.exam_reg_id || member.id;
                const cat = (member.category && String(member.category).toLowerCase()) || '';

                const [hashPart, queryPart] = base.split('?');
                const params = new URLSearchParams(queryPart || '');
                if (regId) params.set('exam_reg_id', regId);
                if (cat) params.set('category', cat);

                const qs = params.toString();
                return hashPart + (qs ? '?' + qs : '');
            },
            // Resolve category for an exam: prefer API category, else from form_heading/name
            getExamCategory(exam) {
                if (!exam) return '';
                const fromApi = (exam.category && String(exam.category).toLowerCase().trim()) || '';
                if (fromApi) return fromApi;
                return this.getCategoryFromExamName(exam.form_heading || exam.name || '');
            },
            // Return the active exam for a given category. When multiple exams match (e.g. QVP MODEL + QVP General),
            // prefer one that has Comments (allowed mobiles) so the restriction applies; then one with countdown.
            getActiveExamForCategory(category) {
                if (!category || !this.examFormsList || this.examFormsList.length === 0) return null;
                const cat = String(category).toLowerCase().trim();
                const matches = this.examFormsList.filter(exam => this.getExamCategory(exam) === cat);
                if (matches.length === 0) return null;
                if (matches.length === 1) return matches[0];
                // Prefer exam that has Comments (allowed list) so visibility restriction is applied
                const withComments = matches.find(exam => this.getAllowedMobilesFromExamComments(exam).length > 0);
                if (withComments) return withComments;
                // Else prefer one with a countdown (future start), then in progress, then any
                const withCountdown = matches.find(exam => this.getCountdownToStart(exam));
                if (withCountdown) return withCountdown;
                const inProgress = matches.find(exam => this.isExamStarted(exam) && !this.isExamEnded(exam));
                return inProgress || matches[0];
            },
            // Exam this member is allowed to see in this category. When same category has a restricted exam (Comments)
            // and an open exam (no Comments), restricted users see the restricted exam; others see the open exam's countdown.
            // When only restricted exam(s) exist, still return one so "rest" see that exam's countdown (Comments = early access only).
            getVisibleExamForMember(category, member) {
                if (!member || !this.examFormsList || this.examFormsList.length === 0) return null;
                let cat = category ? String(category).toLowerCase().trim() : '';

                // No category on registration (old records) — fall back to any started/active non-kids exam
                if (!cat) {
                    const fallback = this.examFormsList.find(exam => {
                        const ec = this.getExamCategory(exam);
                        return ec && ec !== 'kids' && this.isExamStarted(exam) && !this.isExamEnded(exam);
                    }) || this.examFormsList.find(exam => this.getExamCategory(exam) !== 'kids');
                    return fallback || null;
                }

                const matches = this.examFormsList.filter(exam => this.getExamCategory(exam) === cat);
                if (matches.length === 0) return null;
                // Prefer restricted exam if this member is in its Comments list (early access)
                const restrictedAndAllowed = matches.find(exam =>
                    this.hasExamAllowedMobilesList(exam) && this.isMemberInExamComments(exam, member)
                );
                if (restrictedAndAllowed) return restrictedAndAllowed;
                // Else prefer an exam with no Comments (available to all) so others see its countdown
                const openExam = matches.find(exam => !this.hasExamAllowedMobilesList(exam));
                if (openExam) return openExam;
                // Else only restricted exam(s) exist: return first so "rest" see countdown (button after start time)
                return matches[0] || null;
            },
            getExamStartEpoch(exam) {
                if (!exam) return null;
                return exam.starting_time ?? exam.start_time_epoch ?? null;
            },
            getExamEndEpoch(exam) {
                if (!exam) return null;
                return exam.ending_time ?? exam.end_time_epoch ?? null;
            },
            isExamStarted(exam) {
                const start = this.getExamStartEpoch(exam);
                return start != null && this.countdownNow >= start;
            },
            isExamEnded(exam) {
                const end = this.getExamEndEpoch(exam);
                return end != null && this.countdownNow > end;
            },
            // True when member can see the Take Exam button: either exam has started, or member is in exam Comments (early access - no start time check).
            isExamStartedForMember(exam, member) {
                if (!exam || !member) return false;
                if (this.isExamStarted(exam)) return true;
                return this.hasExamAllowedMobilesList(exam) && this.canShowExamButtonForMember(exam, member);
            },
            // True when member should be treated as "paid" for display: either payment_status is Paid or they have already attended the exam (don't show Pay Now again).
            isMemberPaidOrAttended(member) {
                if (!member) return false;
                if (member.payment_status === 'Paid') return true;
                // Public APIs sometimes send paid status only as HTML/text (payment_status_text).
                // Treat those as paid so public users can see result / exam buttons.
                const pst = (member.payment_status_text && String(member.payment_status_text)) || '';
                if (pst.includes('text-success') || /fees\s*paid/i.test(pst) || pst.includes('ഫീസ് അടച്ചു')) return true;
                if (member.exam_done || member.exam_attempted || member.exam_taken) return true;
                const status = (member.exam_status && String(member.exam_status)) || '';
                return status.includes('എഴുതി') || /exam\s*taken|attended|completed/i.test(status);
            },
            // Show Edit category button only for this registration: hide it only when THIS member has attended/completed the exam for this registration.
            // Paid-but-not-attended: Edit visible. After exam attended for this registration: Edit hidden for that member only.
            shouldShowEditCategory(member) {
                if (!member || !member.category) return true;
                if (member.exam_done || member.exam_attempted || member.exam_taken) return false;
                const status = (member.exam_status && String(member.exam_status)) || '';
                if (status.includes('എഴുതി') || /exam\s*taken|attended|completed/i.test(status)) return false;
                return true;
            },
            // Parse exam comments as allowed mobile numbers (testing): one per line or comma-separated, digits only. Empty/missing = allow all.
            getAllowedMobilesFromExamComments(exam) {
                if (!exam) return [];
                const comments = exam.comments;
                const raw = (comments != null && typeof comments !== 'string') ? String(comments) : (typeof comments === 'string' ? comments : '');
                const trimmed = (raw && raw.trim()) || '';
                if (!trimmed) return [];
                const parts = trimmed.split(/[\n,;]+/).map(s => s.replace(/\D/g, '').trim()).filter(Boolean);
                return [...new Set(parts)];
            },
            // True when exam Comments has at least one allowed mobile (restriction is active).
            hasExamAllowedMobilesList(exam) {
                if (!exam) return false;
                return this.getAllowedMobilesFromExamComments(exam).length > 0;
            },
            // Show exam block (countdown + button) only if: no Comments list (show all) OR member's mobile is in the list.
            canShowExamBlockForMember(exam, member) {
                if (!exam) return false;
                if (!this.hasExamAllowedMobilesList(exam)) return true;
                return this.canShowExamButtonForMember(exam, member);
            },
            // True if member's mobile is in exam Comments list (early access: button before start time).
            isMemberInExamComments(exam, member) {
                if (!exam || !member) return false;
                const allowed = this.getAllowedMobilesFromExamComments(exam);
                if (allowed.length === 0) return false;
                const memberMobile = (member.mobile || member.phone) ? String(member.mobile || member.phone).replace(/\D/g, '') : '';
                if (!memberMobile) return false;
                const normalized = memberMobile.length >= 10 ? memberMobile.slice(-10) : memberMobile;
                return allowed.some(m => {
                    const a = m.length >= 10 ? m.slice(-10) : m;
                    return a === normalized || m === memberMobile;
                });
            },
            // Show "പരീക്ഷ എഴുതുക": everyone can see it when exam has started; Comments list only gives early access (before start).
            canShowExamButtonForMember(exam) {
                if (!exam) return false;
                return true;
            },
            // Returns { days, hours, minutes, seconds } until start, or null if already started
            questionsPageEnabled(exam) {
                if (!exam) return true;
                const q = exam.questions_page_enabled;
                return q !== 'N' && q !== false;
            },
            getCountdownToStart(exam) {
                const start = this.getExamStartEpoch(exam);
                if (start == null || this.countdownNow >= start) return null;
                const diff = start - this.countdownNow;
                return {
                    days: Math.floor(diff / 86400),
                    hours: Math.floor((diff % 86400) / 3600),
                    minutes: Math.floor((diff % 3600) / 60),
                    seconds: diff % 60
                };
            },
            getCountdownToMarksPublishing(exam) {
                // For result-only mode (questions page disabled), we want the countdown
                // to point to the configured start time so that admins can set
                // "result publish" time there. Using end time here was confusing
                // (it showed full start→end duration instead of time to first visibility).
                const start = this.getExamStartEpoch(exam);
                if (start == null || this.countdownNow >= start) return null;
                const diff = start - this.countdownNow;
                return {
                    days: Math.floor(diff / 86400),
                    hours: Math.floor((diff % 86400) / 3600),
                    minutes: Math.floor((diff % 3600) / 60),
                    seconds: diff % 60
                };
            },
            getCountdownBlockVisible(exam) {
                if (!exam) return false;
                if (this.questionsPageEnabled(exam)) return this.getCountdownToStart(exam) != null;
                return this.getCountdownToMarksPublishing(exam) != null;
            },
            formatCountdownDisplay(exam) {
                const c = this.getCountdownToStart(exam);
                if (!c) return '';
                const parts = [];
                if (c.days > 0) parts.push(c.days + ' ദിവസം');
                if (c.hours > 0) parts.push(c.hours + ' മണിക്കൂർ');
                parts.push(c.minutes + ' മിനിറ്റ് ' + c.seconds + ' സെക്കൻഡ്');
                return parts.join(' ');
            },
            formatCountdownToEndDisplay(exam) {
                const c = this.getCountdownToMarksPublishing(exam);
                if (!c) return '';
                const parts = [];
                if (c.days > 0) parts.push(c.days + ' ദിവസം');
                if (c.hours > 0) parts.push(c.hours + ' മണിക്കൂർ');
                parts.push(c.minutes + ' മിനിറ്റ് ' + c.seconds + ' സെക്കൻഡ്');
                return parts.join(' ');
            },
            // Map exam name (form_heading) to category slug for filtering
            getCategoryFromExamName(name) {
                if (!name || typeof name !== 'string') return '';
                const n = name.toLowerCase().trim();
                if (n.includes('general') || n === 'ജനറൽ') return 'general';
                if (n.includes('campus') || n === 'ക്യാമ്പസ്') return 'campus';
                if (n.includes('teens') || n === 'ടീൻസ്') return 'teens';
                if (n.includes('kids') || n === 'കിഡ്സ്') return 'kids';
                if (n.includes('global') || n === 'ഗ്ലോബൽ') return 'global';
                return '';
            },
            // True if user has at least one Paid registration for this category (for enabling "write exam")
            hasPaidRegistrationForCategory(category) {
                if (!category || !this.registeredMembers) return false;
                const cat = String(category).toLowerCase();
                return this.registeredMembers.some(m =>
                    (m.category && String(m.category).toLowerCase() === cat) && m.payment_status === 'Paid'
                );
            },
            getCategoryPillLabel(cat) {
                const labels = { general: 'ജനറൽ', campus: 'ക്യാമ്പസ്', teens: 'ടീൻസ്', kids: 'കിഡ്സ്', global: 'ഗ്ലോബൽ' };
                return labels[String(cat).toLowerCase()] || cat;
            },
            getPaymentUrl() {
                if (!this.currentUser) {
                    return '#';
                }

                // If multiple members selected, use bulk payment
                if (this.selectedMembers.length > 0) {
                    const qvpIds = this.selectedMembers.join(',');
                    return `https://guide.msoftit.com/payment?gway=razorpay&user_id=${this.currentUser.id}&qvp_id=${qvpIds}`;
                }

                // Get all unpaid members for bulk payment (exclude attended - they are treated as paid)
                const unpaidMembers = this.registeredMembers.filter(m => !this.isMemberPaidOrAttended(m) && m.payment_status !== 'Paid');
                
                if (unpaidMembers.length > 0) {
                    // Create comma-separated list of all unpaid member IDs
                    const qvpIds = unpaidMembers.map(m => m.exam_reg_id || m.id).join(',');
                    return `https://guide.msoftit.com/payment?gway=razorpay&user_id=${this.currentUser.id}&qvp_id=${qvpIds}`;
                }

                return '#';
            },
            getSinglePaymentUrl(memberId) {
                if (!this.currentUser) {
                    return '#';
                }
                
                // Find the member to get the correct exam_reg_id
                const member = this.registeredMembers.find(m => m.id === memberId);
                const qvpId = member ? (member.exam_reg_id || member.id) : memberId;
                
                return `https://guide.msoftit.com/payment?gway=razorpay&user_id=${this.currentUser.id}&qvp_id=${qvpId}`;
            },
            onCategoryChange(event) {
                // Ensure the value is properly set
                this.selectedCategory = event.target.value;
                // Description will automatically show via computed property
            },
            onMemberCategoryChange(memberId) {
                // Category selected for a specific member (Vue 3: no $set/$delete; use replacement)
                console.log(`Category selected for member ${memberId}:`, this.memberCategories[memberId]);
                const member = this.familyMembers.find(m => m.id === memberId);
                const userMobile = this.isCurrentUserMember(member) ? this.displayMobile : '';
                const emptyCampus = {
                    campus_name: '',
                    campus_course: '',
                    campus_year: '',
                    campus_phone: userMobile,
                    campus_whatsapp: userMobile,
                    campus_district_id: ''
                };
                if (this.memberCategories[memberId] === 'campus') {
                    this.memberCampusData = { ...this.memberCampusData, [memberId]: { ...emptyCampus } };
                } else {
                    const next = { ...this.memberCampusData };
                    delete next[memberId];
                    this.memberCampusData = next;
                }
            },
            ensureMemberCampusData(memberId) {
                if (!this.memberCampusData[memberId]) {
                    const member = this.familyMembers.find(m => m.id === memberId);
                    const userMobile = this.isCurrentUserMember(member) ? this.displayMobile : '';
                    this.memberCampusData = {
                        ...this.memberCampusData,
                        [memberId]: {
                            campus_name: '',
                            campus_course: '',
                            campus_year: '',
                            campus_phone: userMobile,
                            campus_whatsapp: userMobile,
                            campus_district_id: ''
                        }
                    };
                }
                return this.memberCampusData[memberId];
            },
            getFamilyMemberName(memberId) {
                const member = this.familyMembers.find(m => m.id === memberId);
                return member ? member.name : '';
            },
            isCurrentUserMember(member) {
                // Check if this member is the logged-in user
                if (!this.currentUser || !member) return false;
                
                try {
                    // Compare by member_id from currentUser (most reliable)
                    if (this.currentUser.member_id && member.id) {
                        return this.currentUser.member_id == member.id;
                    }
                    
                    // Fallback: Compare by name (with flexible matching)
                    if (this.currentUser.name && member.name) {
                        const currentName = this.currentUser.name.toLowerCase().trim();
                        const memberName = member.name.toLowerCase().trim();
                        
                        // Exact match
                        if (currentName === memberName) {
                            return true;
                        }
                        
                        // Check if member name starts with current user name (handles "Habeeb Rahman" vs "Habeeb Rahman M")
                        if (memberName.startsWith(currentName) || currentName.startsWith(memberName)) {
                            return true;
                        }
                    }
                    
                    return false;
                } catch (e) {
                    console.error('Error in isCurrentUserMember:', e);
                    return false;
                }
            },
            async handleRegistration() {
                console.log('=== Starting Registration ===');
                console.log('Selected Family Members:', this.selectedFamilyMembers);
                console.log('Member Categories:', this.memberCategories);
                
                // For guide users with family members, check if any family member is selected
                if (this.familyMembers.length > 0 && this.selectedFamilyMembers.length === 0) {
                    this.showAlert('Please select at least one family member to register', 'error');
                    return;
                }

                // For members who need category selection (age 12, 12-18, 19+), check if all have categories selected
                if (!this.allRequiredCategoriesSelected) {
                    console.log('Category validation failed');
                    this.showAlert('Please select a category for all members who require category selection. For Campus, fill all campus fields.', 'error');
                    return;
                }

                if (!this.isAgreed) {
                    this.showAlert('Please agree to register', 'error');
                    return;
                }

                this.loading = true;
                this.hideAlert();

                try {
                    // Register selected family members
                    if (this.selectedFamilyMembers.length > 0) {
                        let successCount = 0;
                        let errorCount = 0;

                        // Process registrations sequentially to avoid race conditions
                        for (const memberId of this.selectedFamilyMembers) {
                            const member = this.familyMembers.find(m => m.id === memberId);
                            console.log('Processing member:', member.name, 'ID:', memberId, 'Age:', member.age);
                            
                            // Auto-assign category based on age
                            let category;
                            const kidsSubCategory = this.getKidsSubCategory(member.age);
                            
                            if (member.age === 12) {
                                // Age 12: Use selected category (Kids or Teens), default to Kids with Senior
                                category = this.memberCategories[memberId] || 'kids';
                                console.log('Age 12 - Using category:', category);
                            } else if (kidsSubCategory && member.age < 12) {
                                // Kids category (age 0-11)
                                category = 'kids';
                                console.log('Auto-assigned category: kids (sub:', kidsSubCategory, ')');
                            } else if (member.age > 12 && member.age <= 18) {
                                // Age 12-18: Use selected category (Teens, General, or Global), default to Teens
                                category = this.memberCategories[memberId] || 'teens';
                                console.log('Age 12-18 - Using category:', category);
                            } else {
                                // Age 19+: use the individually selected category for this member
                                category = this.memberCategories[memberId];
                                console.log('Using selected category:', category, 'for 19+ member');
                            }

                            const registrationData = {
                                form_name: 'QVP_REGISTRATION',
                                user_type: 'P',
                                category: category,
                                member_id: memberId
                            };
                            
                            // Add kids_subcategory if category is kids
                            if (category === 'kids') {
                                // For age 12, it's always senior. For others, use getKidsSubCategory
                                if (member.age === 12) {
                                    registrationData.kids_subcategory = 'senior';
                                } else {
                                    const subCategory = this.getKidsSubCategory(member.age);
                                    if (subCategory) {
                                        registrationData.kids_subcategory = subCategory;
                                    }
                                }
                            }
                            // Add campus fields if category is campus
                            if (category === 'campus' && this.memberCampusData[memberId]) {
                                const cd = this.memberCampusData[memberId];
                                registrationData.campus_name = cd.campus_name;
                                registrationData.campus_course = cd.campus_course;
                                registrationData.campus_year = cd.campus_year;
                                // Use logged-in user's mobile for guide member (current user)
                                const userMobile = this.isCurrentUserMember(member) ? this.displayMobile : '';
                                registrationData.campus_phone = userMobile || cd.campus_phone;
                                registrationData.campus_whatsapp = userMobile || cd.campus_whatsapp;
                                registrationData.campus_district_id = cd.campus_district_id;
                                const campusDistrict = this.revenueDistricts.find(d => d.id == cd.campus_district_id);
                                registrationData.campus_district_name = campusDistrict ? campusDistrict.name : '';
                                // Resolve org district_id and zone_id from revenue district
                                try {
                                    const distRes = await fetch('https://guideportal.wisdomislam.org/api/public/qvp/district-by-revenue?revenue_district_id=' + cd.campus_district_id);
                                    const distJson = await distRes.json();
                                    if (distJson.status === 'success' && distJson.data) {
                                        registrationData.district_id = distJson.data.id;
                                        const zoneRes = await fetch('https://guideportal.wisdomislam.org/api/public/qvp/zones?revenue_district_id=' + cd.campus_district_id);
                                        const zoneJson = await zoneRes.json();
                                        if (zoneJson.status === 'success' && zoneJson.data && zoneJson.data.length > 0) {
                                            registrationData.zone_id = zoneJson.data[0].id;
                                        }
                                    }
                                } catch (e) {
                                    console.error('Campus district resolution failed:', e);
                                }
                            }
                            
                            console.log('Registration data:', registrationData);

                            try {
                                const response = await UserService.addAdmin('auto-form-submit', registrationData);
                                console.log('API response for', member.name, ':', response);
                                console.log('Response data:', response.data);
                                
                                // Handle different response formats
                                if (response && response.data) {
                                    if (response.data.status == 'success' || response.data.status === 'success') {
                                        successCount++;
                                        console.log('Successfully registered:', member.name);
                                        this.markLocalRegistrationSuccess(memberId, category);
                                        this.persistRegisteredIds([memberId]);
                                    } else {
                                        errorCount++;
                                        console.error('Registration failed for', member.name, ':', response.data.message || 'Unknown error');
                                    }
                                } else {
                                    errorCount++;
                                    console.error('Invalid response format for', member.name, ':', response);
                                }
                            } catch (error) {
                                errorCount++;
                                console.error('Error registering member:', member.name, memberId, error);
                                console.error('Error details:', error.response || error.message);
                            }
                        }
                        
                        console.log('Registration complete. Success:', successCount, 'Errors:', errorCount);

                        if (successCount > 0) {
                            this.showAlert(`Successfully registered ${successCount} member(s) for QVP!`, 'success');
                            
                            // Clear form data
                            this.selectedCategory = '';
                            this.isAgreed = false;
                            this.selectedFamilyMembers = [];
                            this.memberCategories = {}; // Clear category selections
                            
                            // Reload registration data after a short delay to ensure DB is updated
                            setTimeout(() => {
                                console.log('Reloading registration data...');
                                this.checkExistingRegistration();
                            }, 1000);
                        }
                        if (errorCount > 0) {
                            this.showAlert(`Failed to register ${errorCount} member(s). Please try again.`, 'error');
                        }
                        
                        // If no members were processed, show error
                        if (successCount === 0 && errorCount === 0) {
                            this.showAlert('No members were selected for registration.', 'error');
                        }
                    } else {
                        // No family members selected
                        this.showAlert('Please select at least one family member to register.', 'error');
                    }
                } catch (error) {
                    console.error('Registration error:', error);
                    const errorMessage = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        'Registration failed. Please try again.';

                    // Handle authentication errors specifically
                    if (error.response && error.response.status === 401) {
                        this.showAlert('Authentication failed. Please login again.', 'error');
                        setTimeout(() => {
                            this.$router.push('/login');
                        }, 2000);
                    } else {
                        this.showAlert(errorMessage, 'error');
                    }
                } finally {
                    // Always reset loading state, even if there's an error
                    this.loading = false;
                    console.log('Registration process completed. Loading reset.');
                }
            },
            showAlert(msg, type) {
                this.alertMessage = msg;
                this.alertClass = type === 'error' ? 'alert-error' : 'alert-success';
                setTimeout(() => {
                    this.hideAlert();
                }, 5000);
            },
            hideAlert() {
                this.alertMessage = '';
                this.alertClass = '';
            },
            redirectToRegisterPage() {
                // Redirect to public registration page with mobile number
                const mobile = this.displayMobile;
                
                // Store mobile in localStorage so it can be pre-filled
                if (mobile) {
                    localStorage.setItem('qvp_registration_mobile', mobile);
                    // Set a flag to indicate user wants to add family members
                    localStorage.setItem('qvp_add_family_mode', 'true');
                }
                
                // Redirect to public QVP registration page (relative path works for both local and production)
                this.$router.push('/qvp');
            },
            getExamCenterName(center) {
                if (!center) return '';
                if (center.madrasa_name) return center.madrasa_name;
                if (center.madrasa && center.madrasa.name) return center.madrasa.name;
                return center.convenor_name || '';
            },
            formatExamCenterDate(d) {
                if (!d) return '';
                const dt = new Date(d + 'T00:00:00');
                if (isNaN(dt.getTime())) return d;
                const day = String(dt.getDate()).padStart(2, '0');
                const month = String(dt.getMonth() + 1).padStart(2, '0');
                const year = dt.getFullYear();
                return `${day}-${month}-${year}`;
            },
            fetchZoneExamCenters() {
                const zoneId = this.currentUser?.zone_id;
                if (!zoneId || !this.hasKidsRegistration) return;
                UserService.authGetRequest('qvp-kids-exam-centers', { zone_id: zoneId })
                    .then((res) => {
                        if (res.data.status === 'success' && Array.isArray(res.data.data?.list)) {
                            this.zoneExamCenters = res.data.data.list;
                        } else {
                            this.zoneExamCenters = [];
                        }
                    })
                    .catch(() => {
                        this.zoneExamCenters = [];
                    });
            },
            getKidsSubCategory(age) {
                // Calculate birth year based on current year (2026)
                const currentYear = 2026;
                const birthYear = currentYear - age;
                
                // Category 1: Junior - Born after 2017 (2018 onwards) = age 0-8 in 2026
                if (birthYear > 2017) {
                    return 'junior';
                }
                // Category 2: Senior - Born 2014-2017 = age 9-12 in 2026
                else if (birthYear >= 2014 && birthYear <= 2017) {
                    return 'senior';
                }
                
                return null;
            },
            async fetchRevenueDistricts() {
                try {
                    const res = await fetch('https://guideportal.wisdomislam.org/api/public/qvp/revenue-districts');
                    const data = await res.json();
                    if (data.status === 'success' && data.data) {
                        this.revenueDistricts = data.data;
                    }
                } catch (e) {
                    console.error('Failed to fetch revenue districts:', e);
                }
            },
            loadFamilyMembers() {
                // Load all family members for guide users
                const isPublicUser = this.currentUser && this.currentUser.signup_url === 'qvp';
                
                // Only load family members for guide users (not public users)
                if (isPublicUser) {
                    console.log('Skipping family members load - public user');
                    return;
                }
                
                console.log('Loading family members using authenticated API');
                
                UserService.addAdmin('get-family-members-for-qvp', {}).then(
                    (response) => {
                        console.log('Family members API response:', response.data);
                        
                        if (response.data.status === 'success' && response.data.data) {
                            // Map family members and check registration status
                            const allMembers = response.data.data.map(member => {
                                // Check if this member is in registeredMembers list
                                const isRegistered = this.registeredMembers.some(regMember => 
                                    regMember.id === member.id || regMember.member_id === member.id
                                );
                                
                                return {
                                    id: member.id,
                                    name: member.name,
                                    age: member.age,
                                    gender: member.gender,
                                    mobile: member.mobile,
                                    is_registered: isRegistered
                                };
                            });
                            
                            // Merge with existing familyMembers data
                            allMembers.forEach(newMember => {
                                const existingIndex = this.familyMembers.findIndex(m => m.id === newMember.id);
                                if (existingIndex === -1) {
                                    // Add new member if not already in the list
                                    this.familyMembers.push(newMember);
                                } else {
                                    // Update existing member data
                                    this.familyMembers[existingIndex] = {
                                        ...this.familyMembers[existingIndex],
                                        ...newMember
                                    };
                                }
                            });
                            
                            console.log('Successfully loaded family members:', this.familyMembers);
                            console.log('Unregistered family members:', this.unregisteredFamilyMembers);
                        }
                    },
                    (error) => {
                        console.error('Error loading family members:', error);
                    }
                );
            }
        }
    };
  </script>
  
  <style scoped>
    /* Banner Section Styles */
    .banner-section {
        width: 100%;
        margin-bottom: 0;
        padding: 15px 15px 0 15px; /* Space on top, right, and left */
    }

    .banner-item {
        width: 100%;
        margin-bottom: 0;
    }

    .banner-image {
        width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
        border-radius: 12px; /* Rounded corners */
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
    }

    .countdown-block {
        font-size: 14px;
        padding: 8px 12px;
        background: rgba(26, 65, 140, 0.08);
        border-radius: 8px;
        border: 1px solid rgba(26, 65, 140, 0.2);
    }
    .countdown-exam-name {
        font-size: 15px;
    }
    .countdown-value {
        font-size: 15px;
        font-weight: 600;
    }

    .categories-section {
        margin-bottom: 20px;
    }
  
    .section-title {
        font-size: 18px;
        font-weight: 600;
        color: #1a418c;
        margin-bottom: 10px;
        margin-top: 5px;
    }
  
    .form-group {
        margin-bottom: 15px;
    }
  
    .form-label {
        font-size: 14px;
        font-weight: 600;
        color: #1a418c;
        margin-bottom: 8px;
        display: block;
    }
  
    .form-control.custom-select {
        width: 100%;
        padding: 12px 15px;
        min-height: 48px;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        font-size: 16px;
        line-height: 1.5;
        background-color: #f8f9fa !important;
        color: #212529 !important;
        cursor: pointer;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        transition: border-color 0.2s, box-shadow 0.2s;
    }
  
    /* Force text color for selected value */
    .form-control.custom-select:not([value=""]),
    .form-control.custom-select[value]:not([value=""]),
    select.form-control.custom-select:not([value=""]),
    select.form-control.custom-select[value]:not([value=""]) {
        color: #212529 !important;
        -webkit-text-fill-color: #212529 !important;
    }
  
    .form-control.custom-select option {
        color: #212529 !important;
        background-color: #fff !important;
        padding: 10px;
    }
  
    .form-control.custom-select option:disabled {
        color: #6c757d !important;
    }
  
    .form-control.custom-select:focus {
        outline: none;
        border-color: #1a418c;
        box-shadow: 0 0 0 3px rgba(26, 65, 140, 0.1);
    }
  
    /* Ensure selected value is visible */
    .form-control.custom-select,
    .form-control.custom-select:not([value=""]),
    .form-control.custom-select[value]:not([value=""]) {
        color: #212529 !important;
    }
  
    .category-description-box {
        background: #f8f9fa;
        border-radius: 12px;
        padding: 20px 18px;
        margin-top: 20px;
        margin-bottom: 10px;
        border-left: 4px solid #1a418c;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }
  
    .description-title {
        font-size: 16px;
        font-weight: 600;
        color: #1a418c;
        margin-bottom: 12px;
        margin-top: 0;
    }
  
    .description-text {
        font-size: 14px;
        color: #212529;
        line-height: 1.7;
        margin-bottom: 12px;
        margin-top: 0;
    }
  
    .sub-categories {
        margin-top: 15px;
        padding-left: 15px;
        padding-top: 10px;
        border-top: 1px solid #dee2e6;
    }
  
    .sub-category-item {
        font-size: 14px;
        color: #212529;
        line-height: 1.8;
        margin-bottom: 10px;
        padding-left: 5px;
    }
  
    .sub-category-item strong {
        color: #1a418c;
    }
  
    .user-section {
        margin-top: 25px;
        margin-bottom: 20px;
    }
  
    .user-card {
        background: #f8f9fa;
        border-radius: 12px;
        padding: 15px;
    }
  
    .user-info {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
    }
  
    .user-avatar {
        width: 45px;
        height: 45px;
        background: #e3f2fd;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
    }
  
    .user-details {
        flex: 1;
    }
  
    .user-name {
        font-size: 16px;
        font-weight: 600;
        color: #1a418c;
        margin-bottom: 3px;
    }
  
    .user-mobile {
        font-size: 13px;
        color: #6c757d;
        margin: 0;
    }
  
    .checkbox-label {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
  
    .checkbox-input {
        width: 18px;
        height: 18px;
        margin-right: 10px;
        cursor: pointer;
        accent-color: #1a418c;
    }
  
    .checkbox-text {
        font-size: 14px;
        color: #212529;
    }

    /* Confirm Section Styling */
    .confirm-section {
        margin-top: 25px;
        margin-bottom: 20px;
    }

    .confirm-card {
        background: #f8f9fa;
        border-radius: 12px;
        padding: 15px;
        border: 1px solid #e0e0e0;
    }

    .selected-members-summary {
        margin-bottom: 15px;
        padding-bottom: 12px;
        border-bottom: 1px solid #dee2e6;
    }

    .summary-title {
        font-size: 14px;
        font-weight: 600;
        color: #1a418c;
        margin-bottom: 10px;
        margin-top: 0;
    }

    .selected-member-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .member-tag {
        display: inline-block;
        padding: 4px 12px;
        background: #e3f2fd;
        color: #1a418c;
        border-radius: 16px;
        font-size: 13px;
        font-weight: 500;
        border: 1px solid #90caf9;
    }

    .confirm-info {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
    }

    .confirm-avatar {
        width: 45px;
        height: 45px;
        background: #e3f2fd;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
    }

    .confirm-details {
        flex: 1;
    }
  
    .alert-box {
        padding: 12px;
        border-radius: 8px;
        margin-bottom: 15px;
        font-size: 14px;
        text-align: center;
        font-weight: 500;
    }
  
    .alert-error {
        background: #fee2e2;
        color: #b91c1c;
    }
  
    .alert-success {
        background: #dcfce7;
        color: #15803d;
    }
  
    .submit-button-wrapper {
        margin-top: 20px;
        margin-bottom: 20px;
        padding-bottom: 10px;
    }
  
    .registered-card {
        border: 2px solid #28a745;
        background: #f8fff9;
    }
  
    .registration-status {
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid #dee2e6;
    }
  
    .status-item {
        margin-bottom: 10px;
        font-size: 14px;
    }
  
    .status-item strong {
        color: #1a418c;
        margin-right: 8px;
    }
  
    .status-badge {
        display: flex;
        align-items: center;
        margin-top: 15px;
        padding: 10px;
        border-radius: 8px;
        font-weight: 600;
    }
  
    .registered-badge {
        background: #d4edda;
        color: #155724;
        border: 1px solid #c3e6cb;
    }
  
    .registered-badge ion-icon {
        margin-right: 8px;
        font-size: 20px;
    }
  
    .text-success {
        color: #28a745 !important;
    }
  
    .text-danger {
        color: #dc3545 !important;
    }
  
    .payment-button-wrapper {
        margin-top: 20px;
        padding-top: 15px;
        border-top: 1px solid #dee2e6;
    }
  
    .btn-payment {
        background: #e91e63;
        color: white;
        border: none;
        padding: 14px 20px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        text-decoration: none;
        transition: background-color 0.3s;
    }
  
    .btn-payment:hover {
        background: #c2185b;
        color: white;
        text-decoration: none;
    }
  
    .btn-payment ion-icon {
        font-size: 20px;
    }
  
    .qvp-title {
        font-size: 20px;
        font-weight: 800;
        color: #1a418c;
        margin-bottom: 8px;
        margin-top: 5px;
        padding: 0 10px;
        letter-spacing: 0.5px;
    }
  
    .qvp-description {
        font-size: 13px;
        color: #212529;
        margin-bottom: 15px;
        padding: 0 10px;
        line-height: 1.5;
    }
  
    .registered-members-section {
        margin-top: 10px;
    }

    /* Ensure download card section matches registered members section styling */
    .section.inset.mt-1 {
        margin-top: 10px;
    }

    .section.inset.mt-1 .wide-block {
        padding: 0;
    }

    .section.inset.mt-1 .listed-detail {
        margin: 0;
        padding: 0 10px; /* Add side padding */
    }
  
    .member-card {
        background: transparent;
        border-radius: 0;
        box-shadow: none;
        margin-bottom: 0;
        border: none;
        border-bottom: 1px solid #f1f3f5;
        overflow: hidden;
    }
  
    .listview li .item {
        display: flex;
        align-items: center;
        padding: 12px 15px;
        min-height: 70px;
    }
  
    .sl-no {
        font-weight: 900;
        margin-right: 15px;
        min-width: 20px;
        color: #1a418c;
        font-size: 18px;
    }
  
    .listview li .in {
        flex: 1;
    }
  
    .member-name {
        font-size: 16px;
        font-weight: 700;
        color: #1a418c;
        display: block;
        margin-bottom: 4px;
    }
  
    .member-mobile {
        color: #1a418c;
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 4px;
    }
  
    .member-category {
        font-size: 12px;
        color: #6c757d;
        margin-bottom: 4px;
    }

    .btn-edit-category {
        margin-left: 8px;
        padding: 4px 10px;
        font-size: 12px;
        background: #1a418c;
        color: #fff;
        border: none;
        border-radius: 6px;
        cursor: pointer;
    }
    .btn-edit-category:hover {
        background: #0d2d66;
    }

    .edit-category-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        padding: 16px;
    }
    .edit-category-modal {
        background: #fff;
        border-radius: 12px;
        padding: 20px;
        max-width: 360px;
        width: 100%;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    }
    .edit-category-modal-with-campus {
        max-height: 90vh;
        overflow-y: auto;
    }
    .edit-category-modal h5 {
        margin: 0 0 8px 0;
        color: #1a418c;
    }
    .edit-category-member-name {
        margin: 0 0 16px 0;
        font-size: 14px;
        color: #495057;
    }
    .edit-campus-fields {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #e9ecef;
    }
    .edit-campus-fields .form-group {
        margin-bottom: 12px;
    }
    .edit-campus-fields .form-group:last-child {
        margin-bottom: 0;
    }
    .edit-mobile-with-code {
        display: flex;
        gap: 10px;
        align-items: stretch;
    }
    .edit-country-code {
        flex: 0 0 100px;
        min-width: 90px;
    }
    .edit-mobile-input {
        flex: 1;
        min-width: 0;
    }
    .edit-campus-whatsapp-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
    }
    .edit-category-error {
        color: #dc3545 !important;
        font-size: 14px;
        font-weight: 500;
        padding: 8px 0;
        margin: 0;
    }
    .edit-category-modal-actions {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        margin-top: 16px;
    }
  
    .category-label {
        font-weight: 500;
        margin-right: 5px;
    }
  
    .category-value {
        color: #1a418c;
        font-weight: 500;
    }
  
    .payment-pending {
        color: #fb5b5a;
        /* Lighter red/pink as in image */
        font-weight: 500;
        font-size: 14px;
    }
  
    .listview li .in footer {
        font-size: 13px;
        color: #6c757d;
        margin-top: 2px;
        display: block;
    }
  
    .payment-status-badge {
        font-weight: 500;
        font-size: 14px;
        margin-top: 4px;
        display: block;
    }
  
    .payment-checkbox {
        margin-left: auto;
        flex-shrink: 0;
    }
  
    .payment-checkbox input[type="checkbox"] {
        display: none;
    }
  
    .payment-checkbox .checkbox-label {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background: #e3f2fd;
        border-radius: 8px;
        /* Slightly more rounded */
        cursor: pointer;
        transition: all 0.2s;
        border: 2px solid #e3f2fd;
    }
  
    .payment-checkbox input[type="checkbox"]:checked+.checkbox-label {
        background: #7ca1f9;
        /* Lighter blue as in shared image? Or gradient? Sticking to a nice blue */
        background: linear-gradient(135deg, #8ba8f7 0%, #6b8df2 100%);
        border: none;
    }
  
    /* Override for standard checkmark color logic if needed */
  
    .payment-checkbox .checkbox-label ion-icon {
        font-size: 18px;
        color: #1a418c;
    }
  
    .payment-checkbox input[type="checkbox"]:checked+.checkbox-label ion-icon {
        color: white;
    }
  
    .action-buttons-wrapper {
        padding: 5px 0 15px;
        margin-top: 0;
    }
  
    .btn-save {
        background: #7d8fb3;
        /* Slatish Blue */
        color: white;
        border: none;
        padding: 12px 15px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 12px;
        width: 100%;
        min-height: 48px;
    }
  
    .btn-save:hover {
        background: #6c7da0;
        color: white;
    }
  
    .btn-save:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
  
    .btn-payment-list {
        background: #eb4d6c;
        /* Slightly softer pink/red */
        color: white;
        border: none;
        padding: 12px 15px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 15px;
        display: block;
        text-align: center;
        text-decoration: none;
        transition: background-color 0.2s;
        min-height: 48px;
        line-height: 24px;
    }

    .btn-payment-list:hover {
        background: #d63d5b;
        color: white;
        text-decoration: none;
    }

    .btn-payment-single {
        background: linear-gradient(135deg, #eb4d6c 0%, #d63d5b 100%);
        color: white;
        border: none;
        padding: 6px 16px;
        border-radius: 6px;
        font-weight: 600;
        font-size: 13px;
        text-align: center;
        text-decoration: none;
        transition: all 0.2s;
        box-shadow: 0 2px 4px rgba(235, 77, 108, 0.3);
    }

    .btn-payment-single:hover {
        background: linear-gradient(135deg, #d63d5b 0%, #c02847 100%);
        color: white;
        text-decoration: none;
        box-shadow: 0 3px 6px rgba(235, 77, 108, 0.4);
        transform: translateY(-1px);
    }

    .btn-payment-single:active {
        transform: translateY(0);
    }

    .btn-add-family {
        background: #28a745;
        /* Green color for add action */
        color: white;
        border: none;
        padding: 12px 15px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 15px;
        display: block;
        text-align: center;
        margin-top: 12px;
        transition: background-color 0.2s;
        min-height: 48px;
        line-height: 24px;
        cursor: pointer;
    }

    .btn-add-family:hover {
        background: #218838;
        color: white;
    }

    .btn-add-family:active {
        transform: scale(0.98);
    }

    .exam-center-info-box {
        background: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 8px;
        padding: 14px;
        border-left: 4px solid #1a418c;
    }
    .exam-center-title {
        font-size: 0.95rem;
        font-weight: 600;
        color: #1a418c;
        margin-bottom: 10px;
    }
    .exam-center-details p {
        margin: 6px 0;
        font-size: 0.9rem;
    }
    .exam-center-details a {
        color: #1a418c;
        text-decoration: none;
    }
    .exam-center-divider {
        margin: 10px 0;
        border: none;
        border-top: 1px solid #dee2e6;
    }

    .family-members-section {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .family-member-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .family-member-item {
        display: flex;
        align-items: center;
        padding: 14px 10px;
        background: transparent;
        border-radius: 0;
        border: none;
        border-bottom: 1px solid #dee2e6;
        cursor: pointer;
        transition: all 0.2s;
        box-shadow: none;
    }

    .family-member-item:hover {
        background: rgba(26, 65, 140, 0.05);
        /* border-color: #1a418c; Removed border change since border is gone */
    }

    .family-member-item:has(input:checked) {
        background: rgba(227, 242, 253, 0.5);
        /* border-color: #1a418c; Removed border change */
    }

    .member-checkbox {
        width: 22px;
        height: 22px;
        margin-right: 15px;
        cursor: pointer;
        accent-color: #1a418c;
        border-radius: 4px;
    }

    .member-info {
        flex: 1;
    }

    .member-name-age {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        margin-bottom: 2px;
    }

    .member-name-age strong {
        font-size: 16px;
        color: #1a418c;
        font-weight: 700;
    }

    .member-self-badge {
        font-size: 11px;
        background: #ffc107;
        color: #000;
        padding: 4px 10px;
        border-radius: 20px;
        font-weight: 600;
        margin-left: 8px;
        white-space: nowrap;
        flex-shrink: 0;
        letter-spacing: 0.3px;
    }

    .member-category-auto {
        font-size: 11px;
        background: #28a745;
        color: white;
        padding: 4px 10px;
        border-radius: 20px;
        font-weight: 600;
        margin-left: 8px;
        white-space: nowrap;
        flex-shrink: 0;
        letter-spacing: 0.3px;
    }

    /* Inline Category Selection */
    .family-member-wrapper {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .inline-category-select {
        margin-left: 0;
        margin-top: -6px;
        padding: 15px 15px 15px 15px;
        background: #e3f2fd;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        border: 1px solid #1a418c;
        border-top: none;
        position: relative;
        z-index: 0;
    }
    
    .family-member-item:has(+ .inline-category-select) {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom-color: transparent;
        z-index: 1;
        position: relative;
    }

    .inline-category-label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: #1a418c;
        margin-bottom: 8px;
    }

    .inline-category-dropdown {
        width: 100%;
        padding: 10px 12px;
        font-size: 16px;
        border: 1px solid #b1c7ec;
        border-radius: 8px;
        background-color: #fff !important;
        color: #212529 !important;
        cursor: pointer;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%231a418c' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 15px center;
        padding-right: 40px;
        height: 44px;
    }

    .inline-category-dropdown:focus {
        outline: none;
        border-color: #1a418c;
        box-shadow: 0 0 0 2px rgba(26, 65, 140, 0.1);
    }

    .inline-category-dropdown option {
        color: #212529 !important;
        background-color: #fff !important;
        padding: 8px;
    }
  
    .member-details {
        font-size: 13px;
        color: #6c757d;
    }

    .category-info-note {
        display: flex;
        align-items: center;
        gap: 8px;
        background: #e9ecef;
        padding: 8px 12px;
        border-radius: 8px;
        margin-bottom: 12px;
        font-size: 12px;
        color: #495057;
    }

    .category-info-note ion-icon {
        font-size: 16px;
        color: #1a418c;
    }

    /* Exam Form Section Styles */
    .exam-form-section {
        padding: 15px;
        text-align: center;
    }

    /* QVP Exam Page Card - four categories at a time */
    .exam-page-card {
        padding: 16px;
        background: linear-gradient(135deg, #f8fafc 0%, #e8f4fc 100%);
        border-radius: 12px;
        border: 1px solid #c5e1f7;
    }

    .exam-page-card-item {
        margin-bottom: 14px;
    }
    .exam-page-card-item:last-child {
        margin-bottom: 0;
    }
    .exam-name {
        font-size: 16px;
        font-weight: 600;
    }

    .exam-pay-first {
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px dashed #dee2e6;
    }

    .exam-page-heading {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 4px;
    }

    .exam-page-sub {
        font-size: 12px;
    }

    .exam-categories-pills {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
        margin-top: 10px;
    }

    .category-pill {
        display: inline-block;
        padding: 4px 10px;
        background: #1a418c;
        color: #fff;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 500;
    }

    .exam-page-title {
        font-size: 13px;
    }

    .exam-button-wrapper {
        margin-top: 15px;
    }

    .exam-button-wrapper a {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 24px;
        text-decoration: none;
        border-radius: 8px;
        font-weight: 500;
    }

    .exam-button-wrapper ion-icon {
        font-size: 20px;
    }

    .btn-exam-quick {
        background: #1a418c;
        color: #fff;
        border: none;
        padding: 6px 14px;
        border-radius: 6px;
        font-size: 13px;
        text-decoration: none;
        display: inline-block;
    }

    .btn-exam-quick:hover {
        background: #153a75;
        color: #fff;
        text-decoration: none;
    }

    .exam-form-section h3 {
        margin-bottom: 15px;
        font-size: 18px;
        font-weight: 600;
    }

    .exam-form-section p {
        margin-bottom: 15px;
        font-size: 14px;
    }

    /* Video Section Styles */
    .video-section {
        padding: 15px;
        text-align: center;
    }

    .video-section p {
        margin-bottom: 15px;
        font-size: 14px;
        color: #495057;
    }

    .video-wrapper {
        position: relative;
        width: 100%;
        padding-bottom: 56.25%; /* 16:9 aspect ratio */
        height: 0;
        overflow: hidden;
        border-radius: 8px;
        margin-top: 15px;
    }

    .video-iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }

  </style>

<style>
    /* Document Download Card Styles - Global for v-html content */
    .document-download-card {
        padding: 0;
        background: transparent;
    }

    .document-download-card .card-text {
        margin-bottom: 15px;
        font-size: 15px;
        font-weight: 600;
        text-align: center;
        color: #1a418c;
        padding: 0 20px !important;
    }

    .document-download-card .listview {
        list-style: none;
        padding: 0;
        margin: 0 15px 10px 15px !important;
        background: transparent;
    }

    .document-download-card .listview li {
        background: transparent !important;
        border-radius: 0;
        box-shadow: none !important;
        margin-bottom: 0;
        border: none !important;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between; /* Ensure content is spread out */
        padding: 0 20px 20px 20px !important; /* Force padding */
        min-height: 50px;
    }

    .document-download-card .listview li:last-child {
        margin-bottom: 0;
    }

    .document-download-card .listview li strong {
        color: #1a418c;
        font-size: 16px;
        font-weight: 700;
        flex: 1;
        margin-right: 10px;
    }

    .document-download-card .listview li span {
        display: flex;
        align-items: center;
    }

    .document-download-card .listview li a {
        color: #fff;
        text-decoration: none;
        font-weight: 500;
        padding: 5px 10px;
        background: #007bff;
        border-radius: 5px;
        font-size: 12px;
        transition: background 0.2s;
        white-space: nowrap;
    }

    .document-download-card .listview li a:hover {
        background: #0056b3;
        text-decoration: none;
    }

    /* Admit card button */
    .btn-admit-card {
        background: #111;
        color: #fff;
        border: 1px solid #111;
        padding: 6px 14px;
        font-size: 13px;
        border-radius: 6px;
        display: inline-block;
    }
    .btn-admit-card:hover,
    .btn-admit-card:active {
        background: #000;
        color: #fff;
    }

    .campus-fields-wrapper {
        padding: 12px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
    }
    .campus-fields-wrapper .form-group {
        margin-bottom: 10px;
    }
    .campus-fields-wrapper .form-group:last-child {
        margin-bottom: 0;
    }
</style>